// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* User Details Page - Compact Modern Design */
.user-details-page {
  position: relative;
  padding: 1.25rem 1.5rem 2rem;
  max-width: 1400px;
  margin: 0 auto;
  min-height: calc(100vh - 80px);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: var(--text-primary);
}

/* Navigation Tabs */
.user-details-nav {
  display: flex;
  gap: 8px;
  margin-bottom: 32px;
  padding: 8px;
  background: var(--bg-primary);
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);
  border: none;
}

.nav-tab {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  background: transparent;
  border: none;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: inherit;
}

.nav-tab:hover:not(.active) {
  background: var(--nav-hover-bg);
  color: var(--text-primary);
}

.nav-tab.active {
  color: white;
}

.profile-nav-active-bg {
  position: absolute;
  inset: 0;
  background: var(--accent-primary);
  border-radius: 8px;
  box-shadow: var(--shadow-sm);
  z-index: 0;
  pointer-events: none;
}

.nav-tab-content {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* Unified Button Styles */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  border: none;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-decoration: none;
  font-family: inherit;
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-primary {
  background: var(--accent-primary);
  color: white;
  box-shadow: var(--shadow-sm);
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  background: var(--accent-hover);
  box-shadow: var(--shadow-md);
}

.btn-secondary {
  background: var(--bg-primary);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
}

.btn-secondary:hover:not(:disabled) {
  background: var(--nav-hover-bg);
  border-color: var(--accent-primary);
}

.btn-back {
  background: var(--bg-secondary);
  color: var(--text-secondary);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
}

.btn-back:hover {
  background: var(--bg-primary);
  color: var(--text-primary);
}

.btn-icon {
  padding: 6px 10px;
  background: var(--nav-hover-bg);
  border: 1px solid var(--border-color);
  font-size: 1rem;
}

.btn-icon:hover:not(:disabled) {
  background: var(--nav-hover-bg);
}

.btn-copy {
  padding: 4px 8px;
  background: var(--nav-hover-bg);
  color: var(--text-secondary);
  font-size: 0.75rem;
  margin-left: 8px;
}

.btn-copy:hover {
  background: var(--nav-hover-bg);
}

.btn-danger {
  background: #ef4444;
  color: white;
  box-shadow: var(--shadow-sm);
}

.btn-danger:hover:not(:disabled) {
  transform: translateY(-1px);
  background: #dc2626;
  box-shadow: var(--shadow-md);
}

.btn-danger-sm {
  padding: 6px 12px;
  font-size: 0.8125rem;
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
  border: 1px solid rgba(239, 68, 68, 0.2);
}

.btn-danger-sm:hover {
  background: rgba(239, 68, 68, 0.2);
}

.btn-action {
  background: var(--bg-secondary);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  padding: 12px 16px;
  justify-content: flex-start;
}

.btn-action:hover {
  background: var(--nav-hover-bg);
  border-color: var(--accent-primary);
  transform: translateX(4px);
}

.tab-content {
  animation: fadeInTab 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes fadeInTab {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* Main Grid Layout */
.user-details-main-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

/* Card Styles */
.details-card {
  background: var(--bg-primary);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.04);
  border: none;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow-anchor: none;
}

.details-card:hover {
  box-shadow: 0 12px 48px rgba(37, 99, 235, 0.12);
  transform: translateY(-4px);
}

.card-full {
  grid-column: span 2;
}

.card-half {
  grid-column: span 1;
}

.card-header {
  padding: 16px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  background: transparent;
}

.card-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--accent-primary);
  flex-shrink: 0;
  line-height: 0;
}

.card-icon svg {
  display: block;
}

.card-icon-circle {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(37, 99, 235, 0.08);
  /* Slightly lighter */
  border: 1px solid rgba(59, 130, 246, 0.2);
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  overflow: hidden;
  flex-shrink: 0;
  color: var(--accent-primary);
  line-height: 0;
}

.card-icon-circle .custom-icon {
  width: 13px !important;
  height: 13px !important;
  display: block;
  margin: 0;
}

.card-content {
  padding: 20px;
}

/* Profile Header */
.profile-header {
  display: flex;
  gap: 24px;
  align-items: center;
}

.profile-avatar {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid var(--bg-primary);
  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.2);
  flex-shrink: 0;
}

.profile-avatar-placeholder {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 2.5rem;
  flex-shrink: 0;
  border: 4px solid var(--bg-primary);
  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.2);
}

.profile-info {
  flex: 1 1;
}

.profile-name-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
  flex-wrap: wrap;
}

.profile-name {
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: -0.015em;
}

.plan-badge {
  padding: 4px 12px;
  border-radius: 99px;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.plan-badge.basic {
  background: rgba(148, 163, 184, 0.12);
  color: #64748b;
  border: 1px solid rgba(148, 163, 184, 0.2);
}

.plan-badge.pro {
  background: rgba(245, 158, 11, 0.1);
  color: #d97706;
  border: 1px solid rgba(245, 158, 11, 0.2);
}

.plan-badge.premium {
  background: rgba(139, 92, 246, 0.1);
  color: #7c3aed;
  border: 1px solid rgba(139, 92, 246, 0.2);
}

.plan-badge.master {
  background: rgba(239, 68, 68, 0.1);
  color: #dc2626;
  border: 1px solid rgba(239, 68, 68, 0.2);
}

.plan-badge.vip {
  background: linear-gradient(135deg, rgba(251, 191, 36, 0.15), rgba(245, 158, 11, 0.15));
  color: #b45309;
  border: 1px solid rgba(245, 158, 11, 0.3);
}

.status-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Order details sidebar: крупнее бейдж статуса, вкладки выше тегов */
.order-sidebar-status-wrap {
  justify-content: center;
  margin-top: 4px;
}

.order-sidebar-status-badge.status-badge {
  padding: 0.55rem 1.2rem !important;
  font-size: 0.875rem !important;
  border-radius: 10px !important;
}

.order-sidebar-tabs {
  margin-top: 16px;
}

.order-sidebar-tags-block {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

[data-theme='dark'] .order-sidebar-tags-block {
  border-top-color: rgba(255, 255, 255, 0.08);
}

.btn-edit-user {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 12px;
  background: var(--bg-primary);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  margin-top: 8px;
}

.btn-edit-user:hover {
  background: var(--nav-hover-bg);
  border-color: #cbd5e1;
  color: var(--accent-primary);
}

.btn-edit-user:active {
  transform: translateY(0);
}

/* Status badge styles moved to status-badge.css */

.profile-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--text-secondary);
  font-size: 0.875rem;
  flex-wrap: wrap;
}

.balance {
  font-weight: 600;
  color: #10b981;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.btn-edit-balance {
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 6px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-edit-balance:hover {
  background: var(--nav-hover-bg);
  color: var(--text-primary);
  transform: scale(1.05);
}

/* Info Rows */
.info-row {
  display: flex;
  align-items: baseline;
  padding-bottom: 8px;
  margin-bottom: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.02);
}

.info-row:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.info-label {
  width: 140px;
  font-size: 0.75rem;
  color: var(--text-secondary);
  font-weight: 600;
  flex-shrink: 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.info-value {
  color: var(--text-primary);
  font-weight: 500;
  font-size: 0.875rem;
  word-break: break-word;
  flex: 1 1;
}

.info-value.highlight {
  color: #10b981;
  font-weight: 700;
}

.info-value.mono {
  font-family: 'SF Mono', 'Courier New', Courier, monospace;
  background: var(--nav-hover-bg);
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.8125rem;
  display: inline-flex;
  align-items: center;
  border: 1px solid var(--border-color);
}

.btn-copy {
  padding: 4px;
  margin-left: 8px;
  background: transparent;
  color: var(--text-secondary);
  border: none;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-copy:hover {
  background: var(--bg-primary);
  color: var(--text-primary);
}

/* Address */
.address-badge {
  display: inline-block;
  background: var(--nav-active-bg);
  color: var(--nav-active-color);
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.address-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 0.875rem;
}

.address-secondary {
  color: var(--text-secondary);
  font-size: 0.8125rem;
}

/* Reviews Container */
.reviews-container {
  background: var(--bg-primary);
  border-radius: 20px;
  padding: 24px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.04);
  border: none;
}

.reviews-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.reviews-header h2 {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.reviews-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.review-card {
  background: var(--bg-primary);
  border-radius: 16px;
  padding: 20px;
  border: 1px solid rgba(0, 0, 0, 0.03);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.02);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.review-card:hover {
  border-color: rgba(37, 99, 235, 0.15);
  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.08);
  transform: translateY(-2px);
}

.review-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.reviewer-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.reviewer-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid var(--border-color);
}

.reviewer-avatar-placeholder {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--accent-primary);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1rem;
}

.reviewer-name {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 0.95rem;
}

.review-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

.review-rating {
  font-size: 0.8125rem;
  color: var(--text-secondary);
}

.review-plan {
  padding: 2px 8px;
  border-radius: 8px;
  font-size: 0.65rem;
  font-weight: 600;
  text-transform: uppercase;
}

.review-plan.basic {
  background: var(--nav-hover-bg);
  color: var(--text-primary);
}

.review-plan.pro {
  background: rgba(245, 158, 11, 0.1);
  color: #f59e0b;
}

.review-date {
  font-size: 0.8125rem;
  color: var(--text-secondary);
}

.review-content {
  position: relative;
}

.review-content p {
  margin: 0;
  padding-right: 96px;
  color: var(--text-primary);
  font-size: 0.875rem;
  line-height: 1.6;
}

.review-actions {
  position: absolute;
  top: 0;
  right: 0;
  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
}

.review-actions .btn-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
}

/* Interaction Container */
.interaction-container {
  background: var(--bg-primary);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
  border: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.interaction-section h2 {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 16px 0;
}

.note-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.note-textarea {
  width: 100%;
  padding: 14px;
  border: 1px solid var(--border-color);
  border-radius: 12px;
  font-size: 0.875rem;
  font-family: inherit;
  resize: vertical;
  background: var(--bg-primary);
  color: var(--text-primary);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.note-textarea:focus {
  outline: none;
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);
}

.note-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.user-comments-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
  margin-bottom: 8px;
}

.user-comment-card {
  border-radius: 12px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.user-comment-card:hover {
  border-color: var(--accent-primary);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  transform: translateY(-2px);
}

.user-comment-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  background: var(--bg-primary);
  border-bottom: 1px solid var(--border-color);
}

.user-comment-card-author {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-comment-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--accent-primary);
  color: #fff;
  font-size: 0.95rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.user-comment-card-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.user-comment-card-name {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-primary);
}

.user-comment-role {
  padding: 2px 8px;
  border-radius: 6px;
  background: rgba(139, 92, 246, 0.1);
  color: var(--accent-primary);
  font-size: 0.7rem;
  font-weight: 600;
  width: fit-content;
}

.user-comment-card-date {
  font-size: 0.8rem;
  color: var(--text-secondary);
  white-space: nowrap;
}

.user-comment-card-body {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background: var(--bg-primary);
}

.user-comment-card-text {
  flex: 1 1;
  min-width: 0;
  font-size: 0.9rem;
  line-height: 1.6;
  color: var(--text-primary);
  white-space: pre-wrap;
  word-break: break-word;
}

.user-comment-card-actions {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  flex-shrink: 0;
  padding-top: 2px;
}

.user-comment-card-actions .btn-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
}

.user-comment-card .user-comment-edit {
  padding: 16px;
  border-top: 1px solid var(--border-color);
  background: var(--bg-primary);
}

.user-comment-card .user-comment-edit .note-textarea {
  margin-bottom: 12px;
}

.user-comment-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
}

.btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-icon:hover {
  background: var(--nav-hover-bg);
  color: var(--text-primary);
  transform: translateY(-1px);
}

.btn-icon.danger {
  color: #ef4444;
}

.btn-icon.danger:hover {
  background: rgba(239, 68, 68, 0.1);
  color: #dc2626;
}

.btn-xs {
  padding: 4px 8px;
  font-size: 0.8rem;
}

.user-comment-edit {
  margin-top: 4px;
}

.status-inline {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 8px;
}

.btn-status {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  color: var(--text-primary);
  justify-content: flex-start;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-status:hover {
  background: var(--nav-hover-bg);
  border-color: var(--accent-primary);
}

.btn-status .order-status-icon {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
}

.btn-status[data-order-status='DONE'] .order-status-icon {
  color: #10b981;
}

.btn-status[data-order-status='DONE_DELETED'] .order-status-icon {
  color: #10b981;
  opacity: 0.6;
}

.btn-status[data-order-status='CANCELED'] .order-status-icon {
  color: #64748b;
}

.btn-status[data-order-status='BLOCKED'] .order-status-icon {
  color: #ef4444;
}

.btn-status.active {
  border-color: var(--accent-primary);
  box-shadow: var(--shadow-sm);
  background: rgba(139, 92, 246, 0.1);
  color: var(--accent-primary);
}

/* Message Toast */
.message-toast {
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 12px 16px;
  border-radius: 10px;
  background: white;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  gap: 12px;
  z-index: 2000;
  animation: slideIn 0.3s ease;
  border-left: 4px solid;
  max-width: 320px;
  font-size: 0.875rem;
}

.message-toast.success {
  border-left-color: #10b981;
}

.message-toast.error {
  border-left-color: #ef4444;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.message-close {
  background: none;
  border: none;
  font-size: 1.25rem;
  color: #94a3b8;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  margin-left: auto;
}

.message-close:hover {
  color: var(--text-secondary);
}

/* Modal */
.user-details-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.42);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
  animation: fadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Keep the same blur on edit/status overlays too */
.user-details-modal-overlay.user-edit-overlay {
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  background: rgba(15, 23, 42, 0.48);
}

.user-details-modal-overlay.transparent {
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: none;
}

/* Balance modal: open higher and use available width */
.user-details-modal-overlay.balance-modal-overlay {
  align-items: flex-start;
  padding: clamp(14px, 6vh, 56px) 16px 24px;
  overflow-y: auto;
}

.user-details-modal-content {
  background: var(--bg-primary);
  border-radius: 20px;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  border: 1px solid var(--border-color);
  overflow: hidden;
  animation: slideUp 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overscroll-behavior: contain;
  overflow-anchor: none;
}

/* Balance modal — match user-edit-modal design */
.user-details-modal-content.balance-modal {
  max-width: min(560px, calc(100vw - 32px));
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  overflow: visible;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.22);
  margin: 0 auto;
  max-height: calc(100vh - clamp(38px, 10vh, 96px));
}

.balance-modal .modal-header {
  flex-shrink: 0;
  padding: 16px 20px;
  background: transparent;
  border-bottom: 1px solid var(--border-color);
  border-radius: 16px 16px 0 0;
}

.balance-modal .modal-header h3 {
  margin: 0;
  font-size: 1.12rem;
  font-weight: 800;
  color: var(--text-primary);
  letter-spacing: -0.01em;
}

.balance-modal .modal-body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 14px 22px 10px;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.balance-modal .balance-form,
.balance-modal .balance-form .form-group {
  width: 100%;
  min-width: 0;
  align-self: stretch;
}

.balance-modal .form-input,
.balance-modal .form-textarea,
.balance-modal textarea.form-input,
.balance-modal .reason-textarea {
  max-width: 100%;
  margin-left: 0;
  margin-right: 0;
  display: block;
  padding: 10px 12px;
  text-align: left;
}

.balance-modal .modal-actions {
  flex-shrink: 0;
  background: var(--bg-primary);
  border-top: 1px solid var(--border-color);
  padding: 12px 22px 14px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 12px;
  border-radius: 0 0 16px 16px;
}

.balance-modal .btn {
  border-radius: 12px;
  padding: 10px 16px;
  min-width: 0;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(50% - 6px);
  max-width: 100%;
}

.balance-modal .modal-actions .btn-secondary {
  border: 1px solid rgba(148, 163, 184, 0.35);
}

.balance-modal .modal-actions .btn-primary {
  box-shadow: 0 12px 30px rgba(59, 130, 246, 0.18);
}

.balance-modal .form-input:focus,
.balance-modal .form-textarea:focus,
.balance-modal .reason-textarea:focus {
  border-color: rgba(59, 130, 246, 0.85);
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.12);
}

/* Balance type selector — two side-by-side toggle buttons */
.balance-type-selector {
  display: flex;
  gap: 8px;
}

.type-btn {
  flex: 1 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 16px;
  border: 1.5px solid var(--border-color);
  background: var(--bg-primary);
  border-radius: 12px;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: inherit;
}

.type-btn:hover {
  border-color: var(--accent-primary);
  background: var(--nav-hover-bg);
  color: var(--text-primary);
}

.type-btn.active {
  border-color: var(--accent-primary);
  background: var(--accent-primary);
  color: #fff;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
}

.type-btn.add.active {
  background: var(--accent-primary);
  border-color: var(--accent-primary);
}

.type-btn.subtract.active {
  background: #ef4444;
  border-color: #ef4444;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.25);
}

/* Current balance card display */
.current-balance-display {
  padding: 14px 18px;
  background: rgba(16, 185, 129, 0.08);
  border: 1px solid rgba(16, 185, 129, 0.2);
  border-radius: 12px;
  font-size: 1.15rem;
  font-weight: 700;
  color: #059669;
  font-family: var(--font-data, 'Fira Code', monospace);
  letter-spacing: 0.02em;
}

/* Reason textarea */
.reason-textarea {
  min-height: 80px;
  resize: vertical;
  padding: 12px 16px;
  border: 1px solid var(--border-color);
  border-radius: 12px;
  font-size: 0.95rem;
  font-family: inherit;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: var(--bg-primary);
  color: var(--text-primary);
}

/* Field error message */
.field-error {
  color: #ef4444;
  font-size: 0.8125rem;
  font-weight: 500;
  margin-top: -2px;
}

/* Confirmation details */
.balance-confirmation-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.conf-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 10px 16px;
  background: var(--bg-secondary);
  border-radius: 10px;
  border: 1px solid var(--border-color);
}

.conf-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-secondary);
}

.conf-value {
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--text-primary);
  text-align: right;
  max-width: 60%;
  word-break: break-word;
}

.conf-value.text-success { color: #10b981; }
.conf-value.text-danger { color: #ef4444; }

/* Balance preview card in confirmation */
.balance-preview-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: rgba(59, 130, 246, 0.06);
  border: 1px solid rgba(59, 130, 246, 0.15);
  border-radius: 12px;
  margin-top: 4px;
}

.preview-item {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: center;
}

.preview-item span:first-child {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.preview-item span:last-child {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-primary);
  font-family: var(--font-data, 'Fira Code', monospace);
}

.preview-separator {
  color: var(--text-secondary);
  opacity: 0.5;
  display: flex;
  align-items: center;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.user-details-modal-content .modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid var(--border-color);
  background: transparent;
}

.user-details-modal-content .modal-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-primary);
}

.user-details-modal-content .modal-body {
  padding: 24px;
}

.user-details-modal-content .modal-body p {
  margin: 0 0 16px 0;
  color: var(--text-secondary);
  font-size: 0.95rem;
  line-height: 1.6;
}

.user-details-modal-content .modal-body p:last-child {
  margin-bottom: 0;
}

.warning-text {
  color: #ef4444;
  font-weight: 600;
}

.user-details-modal-content .modal-actions {
  padding: 16px 24px;
  border-top: 1px solid var(--border-color);
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  background: var(--bg-primary);
}

/* Loading/Empty States */
.loading-state,
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid var(--border-color);
  border-top: 3px solid var(--accent-primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  color: var(--accent-primary);
  opacity: 0.8;
}

.empty-state h3 {
  margin: 0 0 8px 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-primary);
}

.empty-state p {
  margin: 0;
  font-size: 0.875rem;
  color: var(--text-secondary);
}

/* Responsive */
@media (max-width: 1024px) {
  .card-half {
    grid-column: span 2;
  }

  .quick-actions {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .user-details-page {
    padding: 8px;
    margin-top: 8px;
  }

  .user-details-nav {
    flex-direction: column;
  }

  .nav-tab {
    width: 100%;
  }

  .user-details-main-grid {
    grid-template-columns: 1fr;
  }

  .card-full,
  .card-half {
    grid-column: span 1;
  }

  .profile-header {
    flex-direction: column;
    text-align: center;
  }

  .profile-name-row {
    justify-content: center;
  }

  .profile-meta {
    justify-content: center;
  }

  .status-menu {
    width: 100%;
    right: -100%;
  }
}

@media (max-width: 480px) {
  .filter-row {
    grid-template-columns: 1fr;
  }

  .user-details-modal-content {
    width: 95%;
  }

  .user-details-modal-content .modal-actions {
    flex-direction: column;
  }

  .user-details-modal-content .btn {
    width: 100%;
  }
}

/* Balance Change Modal */
.balance-modal {
  max-width: 500px;
}

/* User Edit Modal — ограничение по высоте экрана и прокрутка формы */
.user-edit-modal {
  max-width: 600px;
  max-height: 96vh;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  overflow: visible;
}

.user-edit-modal.modal-content {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.22);
  transform: translateY(-3px);
  overflow: visible;
  border-radius: 16px;
}

.user-edit-modal .modal-header {
  flex-shrink: 0;
  padding: 16px 16px;
  background: transparent;
  border-bottom: 1px solid var(--border-color);
  border-radius: 16px 16px 0 0;
  box-sizing: border-box;
}

.user-edit-modal-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-edit-modal-icon {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  background: var(--nav-hover-bg);
  border: 1px solid var(--border-color);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-primary);
  flex-shrink: 0;
}

.user-edit-modal .modal-header h3 {
  margin: 0;
  font-size: 1.12rem;
  font-weight: 800;
  color: var(--text-primary);
  letter-spacing: -0.01em;
}

.user-edit-modal .modal-body {
  flex: 1 1;
  min-height: 0;
  overflow: visible;
  /* Компактные симметричные отступы — поля совпадают с краем заголовка */
  padding: 12px 16px 14px;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  box-sizing: border-box;
}

.user-edit-modal .modal-actions {
  flex-shrink: 0;
  background: var(--bg-primary);
  border-top: 1px solid var(--border-color);
  padding: 12px 16px 14px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 12px;
  border-radius: 0 0 16px 16px;
  box-sizing: border-box;
}

.user-edit-modal .form-group {
  gap: 6px;
  min-width: 0;
  width: 100%;
  align-items: stretch;
}

/* CustomSelect в модалке: обёртка inline-block иначе сужает ряд и визуально смещает сетку */
.user-edit-modal .form-group > .sort-menu-wrapper {
  display: block;
  width: 100%;
  min-width: 0;
}

.user-edit-modal .form-group .sort-menu-button {
  width: 100%;
  min-width: 0 !important;
  box-sizing: border-box;
}

.user-edit-modal .form-label {
  font-weight: 700;
  margin: 0;
  padding: 0;
  text-align: left;
  align-self: flex-start;
  width: 100%;
}

.user-edit-modal .form-input,
.user-edit-modal .form-textarea,
.user-edit-modal textarea.form-input {
  background: var(--bg-primary);
  border-color: var(--border-color);
  max-width: 100%;
  /* Компактный внутренний отступ — текст не «уезжает» от левого края */
  padding: 10px 12px;
  text-indent: 0;
  text-align: left;
}

.user-edit-modal .form-input:focus,
.user-edit-modal .form-textarea:focus {
  border-color: rgba(59, 130, 246, 0.85);
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.12);
}

.user-edit-modal .btn {
  border-radius: 12px;
  padding: 10px 16px;
  min-width: 0;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(50% - 6px);
  max-width: 100%;
}

@media (max-width: 480px) {
  .user-edit-modal .btn {
    width: 100%;
    flex: 1 1 100%;
    min-width: 0;
  }
}

.user-edit-modal .modal-actions .btn-secondary {
  border: 1px solid rgba(148, 163, 184, 0.35);
}

.user-edit-modal .modal-actions .btn-primary {
  box-shadow: 0 12px 30px rgba(59, 130, 246, 0.18);
}

.edit-user-form {
  display: grid;
  /* minmax(0,1fr) — иначе min-width:auto у колонок раздувает сетку и смещает поля вправо */
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.edit-user-form .form-group.full-width {
  grid-column: span 2;
  min-width: 0;
}

/* Модалка: плотная сетка без смещения колонок */
.user-edit-modal .edit-user-form {
  gap: 12px;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  justify-items: stretch;
}

.status-preview {
  padding: 12px 16px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  font-size: 0.95rem;
  color: var(--text-primary);
  font-weight: 600;
}

.balance-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-primary);
}

.form-input,
.form-textarea {
  width: 100%;
  box-sizing: border-box;
  padding: 12px 16px;
  border: 1px solid var(--border-color);
  border-radius: 12px;
  font-size: 0.95rem;
  font-family: inherit;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: var(--bg-primary);
  color: var(--text-primary);
}

.form-input:focus,
.form-textarea:focus {
  outline: none;
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);
}

.form-input.error,
.form-textarea.error {
  border-color: #ef4444;
}

.form-error {
  color: #ef4444;
  font-size: 0.8125rem;
  margin-top: -4px;
}

.balance-display {
  padding: 12px 16px;
  background: var(--nav-hover-bg);
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 700;
  color: #10b981;
  text-align: center;
}

.balance-type-buttons {
  display: flex;
  gap: 8px;
}

.btn-balance-type {
  flex: 1 1;
  padding: 12px 16px;
  border: 1px solid var(--border-color);
  background: var(--bg-primary);
  border-radius: 12px;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-balance-type:hover {
  border-color: var(--accent-primary);
  background: var(--nav-hover-bg);
  color: var(--text-primary);
}

.btn-balance-type.active {
  border-color: var(--accent-primary);
  background: var(--accent-primary);
  color: white;
  box-shadow: var(--shadow-sm);
}

.balance-preview {
  padding: 16px;
  background: rgba(16, 185, 129, 0.1);
  border: 1px solid #34d399;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.balance-preview-label {
  font-size: 0.95rem;
  color: #065f46;
  font-weight: 600;
}

.balance-preview-value {
  font-size: 1.25rem;
  color: #059669;
  font-weight: 700;
}

.balance-preview.warning {
  background: rgba(239, 68, 68, 0.1);
  border-color: #f87171;
}

.balance-preview.warning .balance-preview-label {
  color: #991b1b;
}

.balance-preview.warning .balance-preview-value {
  color: #dc2626;
}

.balance-warning-text {
  font-size: 0.8125rem;
  color: #ef4444;
  font-weight: 600;
}

.balance-confirm {
  text-align: center;
}

.confirm-icon {
  font-size: 3.5rem;
  margin-bottom: 16px;
  color: var(--accent-primary);
  display: flex;
  justify-content: center;
}

.confirm-text {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 24px;
}

.confirm-details {
  background: var(--bg-primary);
  border-radius: 12px;
  padding: 20px;
  text-align: left;
  border: 1px solid var(--border-color);
}

.confirm-detail-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 10px 0;
  border-bottom: 1px solid var(--border-color);
}

.confirm-detail-row:last-child {
  border-bottom: none;
}

.confirm-detail-label {
  font-size: 0.95rem;
  color: var(--text-secondary);
  font-weight: 600;
}

.confirm-detail-value {
  font-size: 0.95rem;
  color: var(--text-primary);
  font-weight: 700;
  text-align: right;
  max-width: 60%;
  word-break: break-word;
}

.confirm-detail-value.highlight {
  color: #10b981;
  font-size: 1.1rem;
}

.loading-spinner-small {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-right: 8px;
}

/* Company Portfolio Styles - Compact */
.compact-list {
  padding: 8px 0;
}

/* Compact Categories */
.categories-compact {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.category-compact {
  padding: 6px 8px;
  background: var(--bg-primary);
  border-radius: 4px;
  border: 1px solid var(--border-color);
}

.category-title-small {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 0.8125rem;
  display: block;
  margin-bottom: 3px;
}

.category-tags-compact {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
}

.category-tag-small {
  padding: 1px 6px;
  background: #e0e7ff;
  color: #4338ca;
  border-radius: 10px;
  font-size: 0.6875rem;
  font-weight: 500;
}

.category-tag-more {
  padding: 1px 6px;
  background: #cbd5e1;
  color: var(--text-secondary);
  border-radius: 10px;
  font-size: 0.6875rem;
  font-weight: 500;
}

/* Simple Categories List */
.categories-list-simple {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.category-item-simple {
  padding: 8px 12px;
  background: var(--bg-primary);
  border-radius: 6px;
  border: 1px solid var(--border-color);
  color: var(--text-primary);
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s ease;
}

.category-item-simple:hover {
  background: var(--nav-hover-bg);
  border-color: #cbd5e1;
}

/* Compact Regions */
.regions-compact {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.region-badge {
  padding: 4px 10px;
  background: var(--nav-hover-bg);
  color: var(--text-secondary);
  border-radius: 12px;
  font-size: 0.8125rem;
  font-weight: 500;
  border: 1px solid var(--border-color);
}

/* Regions Inline */
.regions-inline {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  line-height: 1.6;
}

.region-inline {
  color: var(--text-primary);
  font-size: 0.875rem;
  font-weight: 500;
}

.region-separator {
  margin-left: 2px;
  color: var(--text-secondary);
}

/* Compact Services */
.services-compact {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 12px;
  padding: 8px 0;
}

.service-compact {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: var(--bg-primary);
  border-radius: 12px;
  border: 1px solid var(--border-color);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.service-compact:hover {
  border-color: var(--accent-primary);
  box-shadow: var(--shadow-sm);
  transform: translateY(-2px);
  background: var(--bg-secondary);
}

.service-name-small {
  font-weight: 500;
  color: var(--text-primary);
  font-size: 0.875rem;
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 16px;
  line-height: 1.5;
}

.service-price-small {
  font-weight: 600;
  color: var(--accent-primary);
  font-size: 0.875rem;
  flex-shrink: 0;
  padding: 4px 12px;
  background: rgba(139, 92, 246, 0.1);
  border-radius: 8px;
  white-space: nowrap;
}

/* Compact Documents */
.documents-compact {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.document-compact {
  padding: 5px 8px;
  background: var(--bg-primary);
  border-radius: 4px;
  border: 1px solid var(--border-color);
}

.document-link-small {
  color: #2563eb;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.8125rem;
  transition: color 0.2s ease;
  display: block;
}

.document-link-small:hover {
  color: #1d4ed8;
  text-decoration: underline;
}

/* Compact Photos */
.photos-compact {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  gap: 6px;
}

.photo-compact {
  position: relative;
  aspect-ratio: 1;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid var(--border-color);
}

.photo-thumbnail-small {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.2s ease;
}

.photo-compact:hover .photo-thumbnail-small {
  transform: scale(1.05);
}

.photo-placeholder-small {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--nav-hover-bg);
  color: var(--text-secondary);
  font-size: 1.5rem;
}

/* Styled Photos Grid */
.photos-grid-styled {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 16px;
  padding: 8px 0;
  contain: layout style;
}

.photo-item-styled {
  position: relative;
  aspect-ratio: 1;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid var(--border-color);
  background: var(--bg-primary);
  box-shadow: var(--shadow-sm);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  contain: layout;
}

.photo-item-styled:hover {
  border-color: var(--accent-primary);
  box-shadow: var(--shadow-md);
  transform: translateY(-4px);
}

/* .photo-link — это <button>, открывающий просмотрщик, поэтому сбрасываем стили кнопки */
.photo-link {
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  font: inherit;
  color: inherit;
}

.photo-link:focus-visible {
  outline: 2px solid var(--accent-primary);
  outline-offset: -2px;
}

/* Кнопка «Ещё N» / «Свернуть» под сеткой фото */
.photos-toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  padding: 7px 14px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-primary);
  color: var(--text-secondary);
  font-size: 0.8125rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.photos-toggle-btn:hover {
  border-color: var(--accent-primary);
  color: var(--text-primary);
  background: var(--nav-hover-bg);
}

.photo-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.photo-link:hover .photo-image {
  transform: scale(1.08);
}

.photo-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(2px);
}

.photo-link:hover .photo-overlay {
  opacity: 1;
}

.photo-icon {
  font-size: 2rem;
  color: white;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.4));
  transform: translateY(10px);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.photo-link:hover .photo-icon {
  transform: translateY(0);
}

.photo-placeholder-styled {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--nav-hover-bg);
  color: var(--text-secondary);
  gap: 8px;
}

.photo-placeholder-icon {
  font-size: 2rem;
  color: var(--accent-primary);
  opacity: 0.8;
}

.photo-placeholder-text {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-secondary);
}

/* Legacy styles for backward compatibility */
.categories-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.category-item {
  padding: 8px 12px;
  background: var(--bg-primary);
  border-radius: 6px;
  border: 1px solid var(--border-color);
}

.category-title {
  font-weight: 600;
  color: var(--text-primary);
  display: block;
  margin-bottom: 4px;
}

.category-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}

.category-tag {
  padding: 2px 8px;
  background: #e0e7ff;
  color: #4338ca;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
}

.regions-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.region-item {
  padding: 6px 10px;
  background: var(--bg-primary);
  border-radius: 6px;
  border: 1px solid var(--border-color);
  display: flex;
  align-items: center;
  gap: 8px;
}

.region-name {
  font-weight: 500;
  color: var(--text-primary);
}

.region-code {
  font-size: 0.75rem;
  color: var(--text-secondary);
}

.services-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.service-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  background: var(--bg-primary);
  border-radius: 6px;
  border: 1px solid var(--border-color);
}

.service-name {
  font-weight: 500;
  color: var(--text-primary);
}

.service-price {
  font-weight: 600;
  color: #059669;
}

.documents-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.document-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  background: var(--bg-primary);
  border-radius: 6px;
  border: 1px solid var(--border-color);
}

.document-link {
  color: #2563eb;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

.document-link:hover {
  color: #1d4ed8;
  text-decoration: underline;
}

.document-size {
  font-size: 0.75rem;
  color: var(--text-secondary);
  margin-left: auto;
}

.photos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 12px;
}

.photo-item {
  position: relative;
  aspect-ratio: 1;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--border-color);
}

.photo-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.2s ease;
}

.photo-item:hover .photo-thumbnail {
  transform: scale(1.05);
}

.photo-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--nav-hover-bg);
  color: var(--text-secondary);
  font-size: 0.875rem;
}

/* Schedule Display Styles */
.schedule-display-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px dashed var(--border-color);
}

.schedule-display-wrapper:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.schedule-display {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 4px;
}

.schedule-day {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: var(--bg-primary);
  border-radius: 8px;
  border: 1px solid var(--border-color);
  font-size: 0.875rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.schedule-day:hover {
  background: var(--nav-hover-bg);
  border-color: var(--accent-primary);
  transform: translateX(4px);
}

.schedule-day-name {
  font-weight: 600;
  color: var(--text-primary);
  min-width: 100px;
  flex-shrink: 0;
}

.schedule-day-off {
  color: #ef4444;
  font-weight: 600;
  font-size: 0.75rem;
  padding: 4px 10px;
  background: rgba(239, 68, 68, 0.1);
  border-radius: 12px;
}

.schedule-flexible {
  color: var(--accent-primary);
  font-weight: 600;
  font-size: 0.75rem;
  padding: 4px 10px;
  background: rgba(139, 92, 246, 0.1);
  border-radius: 12px;
}

.schedule-intervals {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.schedule-interval {
  color: #10b981;
  font-weight: 600;
  font-size: 0.75rem;
  padding: 4px 10px;
  background: rgba(16, 185, 129, 0.1);
  border-radius: 8px;
  white-space: nowrap;
}

/* Orders Container */
.orders-container {
  background: var(--bg-primary);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
  border: 1px solid var(--border-color);
}

.orders-header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 16px;
}

.orders-header-section h2 {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.orders-sort-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.sort-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-secondary);
}

.sort-select {
  padding: 6px 12px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  font-size: 0.875rem;
  background: white;
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.2s ease;
}

.sort-select:hover {
  border-color: #3b82f6;
}

.sort-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.btn-sort-direction {
  padding: 6px 10px;
  min-width: 36px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
  font-size: 1rem;
  font-weight: 600;
}

.btn-sort-direction:hover {
  background: var(--nav-hover-bg);
  border-color: #cbd5e1;
}

.orders-table-wrapper {
  overflow-x: auto;
  margin-bottom: 16px;
}

.orders-table-simple {
  width: 100%;
  border-collapse: collapse;
  background: transparent;
}

.orders-table-simple thead {
  background: var(--nav-hover-bg);
  border-bottom: 2px solid var(--border-color);
}

.orders-table-simple th {
  padding: 14px 16px;
  text-align: left;
  font-size: 0.8125rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-secondary);
  white-space: nowrap;
}

.orders-table-simple td {
  padding: 16px;
  border-bottom: 1px solid var(--border-color);
  font-size: 0.875rem;
  color: var(--text-primary);
  vertical-align: middle;
}

.orders-table-simple tbody tr:hover {
  background: var(--nav-hover-bg);
}

.order-id-cell {
  font-family: 'Courier New', monospace;
}

.order-id-text {
  color: var(--text-secondary);
  font-size: 0.8rem;
}

.order-title-cell {
  max-width: 300px;
}

.order-title-cell span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.order-status-cell {
  white-space: nowrap;
}

.order-accepted-cell {
  text-align: center;
}

.accepted-yes {
  color: #16a34a;
  font-size: 1.2rem;
  font-weight: 600;
}

.accepted-no {
  color: #dc2626;
  font-size: 1.2rem;
  font-weight: 600;
}

.order-date-cell {
  white-space: nowrap;
  color: var(--text-secondary);
  font-size: 0.8rem;
}

.order-actions-cell {
  white-space: nowrap;
}

.btn-link-sm {
  padding: 4px 10px;
  font-size: 0.8rem;
  background: #3b82f6;
  color: white;
  text-decoration: none;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.btn-link-sm:hover {
  background: #2563eb;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);
}

.orders-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 16px;
  border-top: 1px solid var(--border-color);
  flex-wrap: wrap;
}

.pagination-info {
  font-size: 0.875rem;
  color: var(--text-secondary);
  font-weight: 500;
}

.page-size-select {
  padding: 6px 10px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  font-size: 0.875rem;
  background: white;
  color: var(--text-primary);
  cursor: pointer;
  margin-left: auto;
}

.page-size-select:hover {
  border-color: #3b82f6;
}

.page-size-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* ==========================================================
   RADICAL DASHBOARD LAYOUT & BENTO GRID 
   ========================================================== */

.user-profile-dashboard {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 24px;
  align-items: start;
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
}

@media (max-width: 1200px) {
  .user-profile-dashboard {
    grid-template-columns: 280px 1fr;
  }
}

/* LEFT SIDEBAR (Minimalist) */
.profile-sidebar {
  position: sticky;
  top: 100px;
  padding: 20px;
  background: var(--bg-primary);
  z-index: 10;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  border: 1px solid var(--border-color);
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.profile-stats-sidebar {
  position: sticky;
  top: 100px;
  z-index: 10;
}

[data-theme='dark'] .profile-sidebar {
  background: var(--bg-secondary);
  border-color: var(--border-color);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.sidebar-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  padding-bottom: 8px;
  border-bottom: none;
}

[data-theme='dark'] .sidebar-header {
  border-bottom-color: rgba(255, 255, 255, 0.06);
}

.sidebar-avatar,
.sidebar-avatar-placeholder {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  border: none;
  box-shadow: none;
  flex-shrink: 0;
}

.sidebar-avatar-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  font-weight: 700;
  color: white;
  background: linear-gradient(135deg, #3b82f6, #60a5fa);
}

.sidebar-avatar-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

/* Аватар кликабелен — открывает просмотрщик */
.sidebar-avatar-button {
  position: relative;
  display: block;
  padding: 0;
  border: none;
  background: transparent;
  border-radius: 50%;
  cursor: zoom-in;
  line-height: 0;
  overflow: hidden;
}

.sidebar-avatar-zoom {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(15, 23, 42, 0.55);
  color: #fff;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.sidebar-avatar-button:hover .sidebar-avatar-zoom,
.sidebar-avatar-button:focus-visible .sidebar-avatar-zoom {
  opacity: 1;
}

.sidebar-avatar-wrap.status-active {
  box-shadow:
    0 0 0 1px rgba(148, 163, 184, 0.35),
    0 0 0 4px rgba(16, 185, 129, 0.18),
    0 4px 14px rgba(15, 23, 42, 0.14);
}

.sidebar-avatar-wrap.status-inactive {
  box-shadow:
    0 0 0 1px rgba(148, 163, 184, 0.35),
    0 0 0 4px rgba(245, 158, 11, 0.17),
    0 4px 14px rgba(15, 23, 42, 0.14);
}

.sidebar-avatar-wrap.status-blocked {
  box-shadow:
    0 0 0 1px rgba(148, 163, 184, 0.35),
    0 0 0 4px rgba(239, 68, 68, 0.17),
    0 4px 14px rgba(15, 23, 42, 0.14);
}

.sidebar-name {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  padding: 0;
  word-break: break-word;
  max-width: 100%;
}

.sidebar-name-row {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  max-width: 100%;
}

.sidebar-verified-image {
  width: 24px;
  height: 24px;
  display: inline-block;
  object-fit: contain;
  flex-shrink: 0;
}

.sidebar-quick-stats {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 8px;
  border-bottom: none;
}

[data-theme='dark'] .sidebar-quick-stats {
  border-bottom-color: rgba(255, 255, 255, 0.06);
}

.stat-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.85rem;
  gap: 8px;
  padding: 12px 16px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-primary);
  transition: all 0.2s ease;
  cursor: pointer;
}

.stat-item:hover {
  border-color: var(--accent-primary);
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.08);
}

.stat-label {
  color: var(--text-secondary);
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
}

.stat-value {
  color: var(--text-primary);
  font-weight: 600;
  text-align: right;
  white-space: nowrap;
}

.stat-value.mono {
  font-family: 'Fira Code', 'Fira Sans', monospace;
  color: #10b981;
  font-variant-numeric: tabular-nums;
  font-size: 0.85rem;
}

.balance-item {
  background: rgba(16, 185, 129, 0.04);
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px dashed rgba(16, 185, 129, 0.15);
  align-items: flex-start;
  flex-direction: column;
  gap: 6px;
}

.balance-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.stat-value.mono.balance-amount-negative {
  color: #ef4444;
}

.balance-item:has(.balance-amount-negative) {
  background: rgba(239, 68, 68, 0.06);
  border-color: rgba(239, 68, 68, 0.22);
}

/* Баланс маркетплейса (только для CUSTOMER).
   Селекторы с .stat-item — чтобы правило .stat-item из order-details.css
   (flex-direction: row) не ломало колоночную раскладку, если этот файл
   подключился позже. */
.stat-item.marketplace-balance-item {
  cursor: default;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 6px;
  min-width: 0;
  background: rgba(99, 102, 241, 0.05);
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px dashed rgba(99, 102, 241, 0.22);
}

.stat-item.marketplace-balance-item:hover {
  border-color: rgba(99, 102, 241, 0.4);
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.1);
  transform: none;
}

.stat-item.marketplace-balance-item .balance-row {
  min-width: 0;
  justify-content: flex-start;
}

.marketplace-balance-item .marketplace-balance-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  max-width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;
  line-height: 1.3;
  color: #6366f1;
}

.marketplace-balance-item .marketplace-balance-label svg {
  flex-shrink: 0;
}

.marketplace-balance-item .stat-value.mono.marketplace-balance-value {
  color: #6366f1;
  min-width: 0;
  max-width: 100%;
  text-align: left;
  overflow-wrap: anywhere;
  white-space: normal;
}

[data-theme='dark'] .marketplace-balance-item {
  background: rgba(129, 140, 248, 0.08);
  border-color: rgba(129, 140, 248, 0.28);
}

[data-theme='dark'] .marketplace-balance-label,
[data-theme='dark'] .stat-value.mono.marketplace-balance-value {
  color: #a5b4fc;
}

.debt-status-item {
  cursor: default;
  background: rgba(245, 158, 11, 0.07);
  border-color: rgba(245, 158, 11, 0.28);
  align-items: flex-start;
}

.debt-status-item:hover {
  border-color: rgba(245, 158, 11, 0.4);
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.12);
}

.provider-verified-stat {
  cursor: default;
}

.provider-verified-value.is-verified {
  color: #16a34a;
}

.provider-verified-value.is-unverified {
  color: #b45309;
}

.stat-value.debt-status-value {
  color: #b45309;
  font-weight: 600;
  font-size: 0.8rem;
  line-height: 1.3;
  text-align: right;
  white-space: normal;
  max-width: 58%;
  word-break: break-word;
}

[data-theme='dark'] .stat-value.debt-status-value {
  color: #fbbf24;
}

[data-theme='dark'] .debt-status-item {
  background: rgba(245, 158, 11, 0.1);
  border-color: rgba(245, 158, 11, 0.3);
}

[data-theme='dark'] .stat-value.mono.balance-amount-negative {
  color: #f87171;
}

/* SIDEBAR NAVIGATION (Vertical) */
.sidebar-nav {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.nav-tab-side {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  border: 1px solid var(--border-color);
  background: var(--bg-primary);
  color: var(--text-secondary);
  border-radius: 12px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
  width: 100%;
  text-align: left;
}

.nav-tab-side:hover:not(.active) {
  background: var(--nav-hover-bg);
  border-color: #cbd5e1;
  color: var(--text-primary);
}

[data-theme='dark'] .nav-tab-side:hover:not(.active) {
  background: rgba(59, 130, 246, 0.1);
}

.nav-tab-side.active {
  color: var(--accent-primary);
  background: rgba(59, 130, 246, 0.08);
  border-color: rgba(59, 130, 246, 0.3);
  font-weight: 600;
}

.nav-side-active-bg {
  display: none;
}

.nav-tab-side-content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
}

/* MAIN CONTENT AREA */
.profile-dashboard-main {
  min-width: 0;
  /* Prevents overflow in grid */
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* BENTO GRID LAYOUT */
.bento-grid-layout {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  align-items: stretch;
}

.bento-card {
  position: relative;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.03);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.3s ease, opacity 0.3s ease, border-color 0.3s ease;
  cursor: grab;
}

[data-theme='dark'] .bento-card {
  background: rgba(30, 41, 59, 0.4);
  border-color: rgba(255, 255, 255, 0.05);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
}

.bento-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.06);
}

.bento-small {
  grid-column: span 1;
  min-height: 200px;
}

.bento-medium {
  grid-column: span 2;
}

.bento-large {
  grid-column: span 2;
  min-height: 200px;
}

/* RESPONSIVE DASHBOARD */
@media (max-width: 1024px) {
  .user-profile-dashboard {
    grid-template-columns: 1fr;
  }

  .profile-sidebar {
    position: relative;
    top: 0;
    max-width: 100%;
  }

  .bento-grid-layout {
    grid-template-columns: 1fr;
  }

  .bento-small,
  .bento-medium,
  .bento-large {
    grid-column: span 1;
  }
}

/* BENTO CARD UPGRADES */
.bento-card .card-header {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding-bottom: 0 !important;
  margin-bottom: 12px !important;
  border-bottom: none !important;
}

.id-value-fixed {
  flex: 1 1 !important;
  min-width: 0 !important;
  word-break: break-all !important;
  overflow-wrap: break-word !important;
  padding-right: 28px !important;
}

.bento-card .card-icon-circle {
  background: rgba(59, 130, 246, 0.08);
  color: #3b82f6;
  border: none;
  box-shadow: inset 0 0 0 1px rgba(59, 130, 246, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.bento-card .card-title {
  font-size: 0.95rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0;
  color: var(--text-primary);
  letter-spacing: -0.01em;
}

/* Drag & Drop States */
/* Полностью прячем оригинал, чтобы клон летел на пустое место */
/* 1. Превращаем оригинальную карточку в "пустой слот" при взятии */
.bento-card.dragging {
  opacity: 0 !important;
  transition: none !important;
  /* Убираем любые плавные появления для оригинала */
  pointer-events: none;
}

.bento-card.dragging>* {
  opacity: 0 !important;
  /* Прячем контент внутри слота */
}

.bento-card.drag-over {
  border-color: rgba(59, 130, 246, 0.6);
  /* Ячейка-цель слегка уменьшается "вдавливается" */
  transform: scale(0.85);
  box-shadow: inset 0 0 0 2px rgba(59, 130, 246, 0.15), 0 4px 12px rgba(0, 0, 0, 0.05);
  background: rgba(59, 130, 246, 0.04);
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.bento-card.drag-over::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 16px;
  background: rgba(59, 130, 246, 0.04);
  pointer-events: none;
  z-index: 10;
}

.bento-card.pinned {
  border-color: rgba(16, 185, 129, 0.15);
  cursor: default;
}

.bento-card:active:not(.pinned) {
  cursor: grabbing;
}

/* Pin Button */
.btn-pin-card {
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--text-secondary);
  opacity: 0;
  transition: all 0.2s ease;
  padding: 6px;
  border-radius: 8px;
  flex-shrink: 0;
  z-index: 10;
  margin-right: -6px;
}

.bento-card:hover .btn-pin-card {
  opacity: 0.4;
}

.bento-card:hover .btn-pin-card:hover {
  opacity: 1;
  background: rgba(0, 0, 0, 0.04);
}

.btn-pin-card.pinned {
  opacity: 1;
  color: #ef4444;
}

.btn-pin-card.pinned:hover {
  color: #dc2626;
  background: rgba(239, 68, 68, 0.08);
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.06);
}

.info-row:last-child {
  border-bottom: none;
}

.info-label {
  color: var(--text-secondary);
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-weight: 500;
  flex: 1 1;
}

.info-value {
  color: var(--text-primary);
  font-size: 0.9rem;
  font-weight: 500;
  flex: 1.5 1;
  text-align: right;
  word-break: break-all;
}

.info-value.highlight {
  color: #3b82f6;
  font-weight: 600;
}

.info-value.mono-token {
  font-family: 'Fira Code', 'Fira Sans', monospace;
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 0.85rem;
  display: inline-flex;
  align-items: center;
  border: 1px dashed rgba(59, 130, 246, 0.3);
  color: var(--text-primary);
}

[data-theme='dark'] .info-value.mono-token {
  background: rgba(30, 41, 59, 0.5);
  border-color: rgba(96, 165, 250, 0.2);
}

/* ==========================================================
   ACTION TABS UPGRADES (Reviews, Interaction, Orders)
   ========================================================== */

.reviews-container,
.interaction-container,
.orders-container {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-radius: 20px;
  padding: 32px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.03);
}

[data-theme='dark'] .reviews-container,
[data-theme='dark'] .interaction-container,
[data-theme='dark'] .orders-container {
  background: rgba(30, 41, 59, 0.4);
  border-color: rgba(255, 255, 255, 0.05);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
}

/* Refresh Button in Reviews */
.btn-refresh-reviews {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  color: #3b82f6;
  border: 1px solid rgba(59, 130, 246, 0.3);
  padding: 8px 16px;
  border-radius: 99px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-refresh-reviews:hover {
  background: rgba(59, 130, 246, 0.1);
  border-color: rgba(59, 130, 246, 0.5);
}

.btn-refresh-reviews .spinning {
  animation: spin 1s linear infinite;
}

/* Empty States */
.reviews-empty-state {
  opacity: 0.8;
  transform: scale(0.95);
}

/* Interaction Status Segmented Control */
.interaction-section h2 {
  font-size: 1.15rem;
  font-weight: 700;
  margin-bottom: 16px;
  color: var(--text-primary);
}

.status-inline {
  display: inline-flex;
  background: rgba(0, 0, 0, 0.04);
  padding: 6px;
  border-radius: 12px;
  gap: 4px;
  border: 1px solid rgba(0, 0, 0, 0.02);
}

[data-theme='dark'] .status-inline {
  background: rgba(255, 255, 255, 0.05);
}

.status-inline .btn-status {
  background: transparent;
  color: var(--text-secondary);
  border: none;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.status-inline .btn-status:hover {
  background: rgba(0, 0, 0, 0.03);
  color: var(--text-primary);
}

[data-theme='dark'] .status-inline .btn-status:hover {
  background: rgba(255, 255, 255, 0.06);
}

.status-inline .btn-status .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background: currentColor;
  opacity: 0.55;
  transition: all 0.3s ease;
}

.status-inline .btn-status .dot-green { color: #10b981; }
.status-inline .btn-status .dot-yellow { color: #f59e0b; }
.status-inline .btn-status .dot-red { color: #ef4444; }

.status-inline .btn-status.active {
  background: white;
  color: var(--text-primary);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  font-weight: 600;
}

.status-inline .btn-status.active .dot {
  opacity: 1;
  box-shadow: 0 0 0 3px color-mix(in srgb, currentColor 22%, transparent);
}

[data-theme='dark'] .status-inline .btn-status.active {
  background: var(--accent-primary);
  color: #fff;
  box-shadow: 0 4px 14px rgba(59, 130, 246, 0.45);
}

[data-theme='dark'] .status-inline .btn-status.active .dot {
  color: #fff;
  opacity: 1;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.3);
}

/* ── Verification Banner ── */
.verification-banner {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 20px;
  border-radius: 16px;
  border: 1px solid transparent;
  position: relative;
  overflow: hidden;
  transition: box-shadow 0.2s ease;
}

.verification-banner::before {
  content: '';
  position: absolute;
  inset: 0;
  opacity: 0.045;
  pointer-events: none;
}

.verification-banner.is-verified {
  background: linear-gradient(135deg, rgba(22,163,74,0.10) 0%, rgba(16,185,129,0.06) 100%);
  border-color: rgba(22, 163, 74, 0.22);
}

.verification-banner.is-verified::before {
  background: radial-gradient(circle at 0% 50%, #22c55e 0%, transparent 70%);
  opacity: 0.12;
}

.verification-banner.is-unverified {
  background: linear-gradient(135deg, rgba(245,158,11,0.10) 0%, rgba(251,191,36,0.06) 100%);
  border-color: rgba(245, 158, 11, 0.22);
}

.verification-banner.is-unverified::before {
  background: radial-gradient(circle at 0% 50%, #f59e0b 0%, transparent 70%);
  opacity: 0.10;
}

[data-theme='dark'] .verification-banner.is-verified {
  background: linear-gradient(135deg, rgba(34,197,94,0.12) 0%, rgba(16,185,129,0.07) 100%);
  border-color: rgba(34, 197, 94, 0.2);
}

[data-theme='dark'] .verification-banner.is-unverified {
  background: linear-gradient(135deg, rgba(251,191,36,0.12) 0%, rgba(245,158,11,0.07) 100%);
  border-color: rgba(251, 191, 36, 0.2);
}

.verification-banner-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  flex-shrink: 0;
}

.verification-banner.is-verified .verification-banner-icon {
  background: rgba(22, 163, 74, 0.14);
  color: #16a34a;
}

.verification-banner.is-unverified .verification-banner-icon {
  background: rgba(245, 158, 11, 0.14);
  color: #d97706;
}

[data-theme='dark'] .verification-banner.is-verified .verification-banner-icon {
  background: rgba(34, 197, 94, 0.18);
  color: #4ade80;
}

[data-theme='dark'] .verification-banner.is-unverified .verification-banner-icon {
  background: rgba(251, 191, 36, 0.18);
  color: #fbbf24;
}

.verification-banner-body {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
  min-width: 0;
}

.verification-banner-title {
  font-size: 0.78rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-secondary);
}

.verification-banner-status {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
}

.verification-banner.is-verified .verification-banner-status {
  color: #15803d;
}

.verification-banner.is-unverified .verification-banner-status {
  color: #b45309;
}

[data-theme='dark'] .verification-banner.is-verified .verification-banner-status {
  color: #4ade80;
}

[data-theme='dark'] .verification-banner.is-unverified .verification-banner-status {
  color: #fbbf24;
}

.verification-banner-btn {
  flex-shrink: 0;
  border-radius: 10px;
  font-size: 0.84rem;
  font-weight: 600;
  padding: 9px 18px;
  transition: all 0.2s ease;
}

.btn-verify {
  background: #16a34a;
  color: #fff;
  border: none;
  box-shadow: 0 2px 8px rgba(22,163,74,0.28);
}

.btn-verify:hover:not(:disabled) {
  background: #15803d;
  box-shadow: 0 4px 14px rgba(22,163,74,0.36);
  transform: translateY(-1px);
}

.btn-unverify {
  background: transparent;
  color: #b91c1c;
  border: 1px solid rgba(239,68,68,0.32);
}

.btn-unverify:hover:not(:disabled) {
  background: rgba(239,68,68,0.08);
  border-color: rgba(239,68,68,0.5);
}

[data-theme='dark'] .btn-unverify {
  color: #fca5a5;
  border-color: rgba(248,113,113,0.3);
}

[data-theme='dark'] .btn-unverify:hover:not(:disabled) {
  background: rgba(248,113,113,0.1);
}

/* ── Verification Confirm Modal ── */
.verification-confirm-modal {
  max-width: min(560px, calc(100vw - 32px));
}

.verification-confirm-text {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.6;
}

/* Interaction Textarea */
.note-textarea {
  width: 100%;
  padding: 16px;
  background: rgba(255, 255, 255, 0.5);
  border: 1px dashed rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  color: var(--text-primary);
  font-family: inherit;
  font-size: 0.95rem;
  resize: vertical;
  transition: all 0.3s ease;
  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.01);
}

.note-textarea:focus {
  outline: none;
  background: white;
  border: 1px solid #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

[data-theme='dark'] .note-textarea {
  background: rgba(0, 0, 0, 0.1);
  border-color: rgba(255, 255, 255, 0.1);
}

[data-theme='dark'] .note-textarea:focus {
  background: rgba(30, 41, 59, 0.5);
}

/* Save / Clear Buttons */
.note-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
}

.note-actions .btn-secondary {
  background: transparent;
  border: none;
  color: var(--text-secondary);
}

.note-actions .btn-secondary:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.05);
  color: var(--text-primary);
}

.note-actions .btn-primary {
  background: #3b82f6;
  color: white;
  padding: 10px 24px;
  border-radius: 12px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.note-actions .btn-primary:hover:not(:disabled) {
  background: #2563eb;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.4);
}

.card-content {
  padding-top: 4px;
}

/* ===== Interaction tab: section heads + review form ===== */
.interaction-section-head {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 18px;
}

/* Collapsible section toggle (admin review) */
.interaction-section-toggle {
  width: 100%;
  padding: 0;
  border: none;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
  align-items: center;
}

.interaction-section-chevron {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  color: var(--text-secondary);
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.review-section.is-open .interaction-section-chevron {
  transform: rotate(180deg);
}

.review-section.is-collapsed .interaction-section-toggle {
  margin-bottom: 0;
}

.interaction-section-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 12px;
  background: rgba(59, 130, 246, 0.12);
  color: #3b82f6;
}

.interaction-section-icon.accent-amber {
  background: rgba(245, 158, 11, 0.14);
  color: #f59e0b;
}

.interaction-section-titles {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.interaction-section-head h2 {
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  line-height: 1.3;
}

.interaction-section-sub {
  font-size: 0.82rem;
  color: var(--text-secondary);
  margin: 0;
  line-height: 1.4;
}

/* Review form (masters / providers) */
.review-section {
  padding: 20px;
  border-radius: 16px;
  border: 1px solid rgba(245, 158, 11, 0.22);
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.06) 0%, rgba(251, 191, 36, 0.03) 100%);
}

[data-theme='dark'] .review-section {
  border-color: rgba(245, 158, 11, 0.2);
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.08) 0%, rgba(251, 191, 36, 0.04) 100%);
}

.review-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.review-field-label {
  display: block;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-secondary);
  margin-bottom: 8px;
}

.review-input-field,
.review-rating-field {
  display: flex;
  flex-direction: column;
}

.review-stars-input {
  display: flex;
  align-items: center;
  gap: 4px;
}

.review-star-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  border: none;
  background: transparent;
  color: rgba(148, 163, 184, 0.55);
  cursor: pointer;
  border-radius: 8px;
  transition: transform 0.15s ease, color 0.15s ease;
}

.review-star-btn:hover {
  transform: scale(1.15);
}

.review-star-btn.active {
  color: #f59e0b;
}

.review-rating-value {
  margin-left: 10px;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-primary);
}

.review-text-input {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid var(--border-color);
  border-radius: 12px;
  font-size: 0.875rem;
  font-family: inherit;
  background: var(--bg-primary);
  color: var(--text-primary);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.review-text-input::placeholder {
  color: var(--text-secondary);
  opacity: 0.6;
  font-family: monospace;
}

.review-text-input:focus {
  outline: none;
  border-color: #f59e0b;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.12);
}
/* Тёмная тема (DEV): оставшиеся белые поверхности (тост и селекты) */
:root[data-theme='dark'] .message-toast {
  background: var(--bg-card);
  color: var(--text-primary);
}

:root[data-theme='dark'] .sort-select,
:root[data-theme='dark'] .page-size-select {
  background: var(--bg-primary);
  color: var(--text-primary);
}

/* Marketing consent pill (System info card) */
.marketing-consent-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 10px 2px 8px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.6;
  border: 1px solid transparent;
}

.marketing-consent-pill.is-agreed {
  color: #059669;
  background: rgba(16, 185, 129, 0.1);
  border-color: rgba(16, 185, 129, 0.25);
}

.marketing-consent-pill.is-declined {
  color: #dc2626;
  background: rgba(239, 68, 68, 0.08);
  border-color: rgba(239, 68, 68, 0.22);
}

.marketing-consent-pill.is-no-answer {
  color: var(--text-secondary);
  background: var(--bg-tertiary);
  border-color: var(--border-color);
}

:root[data-theme='dark'] .marketing-consent-pill.is-agreed {
  color: #34d399;
}

:root[data-theme='dark'] .marketing-consent-pill.is-declined {
  color: #f87171;
}
`, "",{"version":3,"sources":["webpack://./src/css/user-details.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;EACjB,cAAc;EACd,8BAA8B;EAC9B,8EAA8E;EAC9E,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,iDAAiD;EACjD,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,iCAAiC;EACjC,kBAAkB;EAClB,4BAA4B;EAC5B,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,gBAAgB;EAChB,iDAAiD;EACjD,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,qBAAqB;EACrB,yCAAyC;EACzC,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;EACd,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mCAAmC;EACnC,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,uFAAuF;EACvF,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,qEAAqE;AACrE;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,kDAAkD;;AAElD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yDAAyD;EACzD,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,gCAAgC;EAChC,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,0CAA0C;EAC1C,iDAAiD;AACnD;;AAEA;EACE,qCAAqC;EACrC,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,oBAAoB;EACpB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,6BAA6B;EAC7B,0BAA0B;EAC1B,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,qCAAqC;EACrC,yCAAyC;EACzC,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,mCAAmC;EACnC,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,0BAA0B;EAC1B,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,4BAA4B;EAC5B,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,UAAU;EACV,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mDAAmD;AACrD;;AAEA,mDAAmD;AACnD;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA,uDAAuD;AACvD;EACE,uBAAuB;EACvB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,0CAA0C;EAC1C,qCAAqC;EACrC,gBAAgB;EAChB,oDAAoD;EACpD,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA,iDAAiD;AACjD;EACE,yCAAyC;EACzC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,4CAA4C;EAC5C,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,SAAW;EACX,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;;EAIE,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,yCAAyC;EACzC,uBAAuB;EACvB,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,YAAyB;EAAzB,cAAyB;EAAzB,2BAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,gDAAgD;AAClD;;AAEA;;;EAGE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,uCAAuC;EACvC,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,kDAAkD;EAClD,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,oCAAoC;EACpC,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qDAAqD;EACrD,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,iDAAiD;EACjD,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA,2BAA2B,cAAc,EAAE;AAC3C,0BAA0B,cAAc,EAAE;;AAE1C,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,qDAAqD;AACvD;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,6BAA6B;AAC/B;;AAEA,yBAAyB;AACzB;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;AAClB;;AAEA,qEAAqE;AACrE;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,2CAA2C;EAC3C,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,4CAA4C;EAC5C,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,SAAW;EACX,aAAa;EACb,iBAAiB;EACjB,uEAAuE;EACvE,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,yCAAyC;EACzC,uBAAuB;EACvB,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,SAAS;EACT,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;;AAEA,4FAA4F;AAC5F;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;;AAEA;;;EAGE,6BAA6B;EAC7B,iCAAiC;EACjC,eAAe;EACf,qEAAqE;EACrE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,YAAyB;EAAzB,cAAyB;EAAzB,2BAAyB;EACzB,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;IACX,cAAc;IACd,YAAY;EACd;AACF;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,yFAAyF;EACzF,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,gDAAgD;AAChD;EACE,SAAS;EACT,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,iDAAiD;EACjD,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,qCAAqC;EACrC,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,qCAAqC;EACrC,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,qCAAqC;EACrC,iDAAiD;AACnD;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC,6BAA6B;EAC7B,4BAA4B;EAC5B,iDAAiD;EACjD,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA,yFAAyF;AACzF;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA,gDAAgD;AAChD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uDAAuD;AACzD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,qDAAqD;EACrD,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iDAAiD;EACjD,2BAA2B;EAC3B,uDAAuD;AACzD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,6BAA6B;EAC7B,qCAAqC;EACrC,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;EACnB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;+DAE+D;;AAE/D;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA,8BAA8B;AAC9B;EAEE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,qBAAqB;EACrB,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EAEE,gBAAgB;EAChB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,UAAU;EACV,6BAA6B;AAC/B;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE;;;qCAGmC;AACrC;;AAEA;EACE;;;qCAGmC;AACrC;;AAEA;EACE;;;qCAGmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;EAChD,cAAc;EACd,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,uBAAuB;EACvB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;;;uBAGuB;AACvB;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,QAAQ;EACR,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,6BAA6B;EAC7B,4BAA4B;EAC5B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;EAC1C,wHAAwH;EACxH,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,mBAAmB;EACrB;AACF;;AAEA,wBAAwB;AACxB;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,oBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,YAAY;EACZ,mDAAmD;EACnD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB,gEAAgE;AAChE,mEAAmE;AACnE;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,kDAAkD;EAClD,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,kDAAkD;EAClD,sBAAsB;EACtB,oFAAoF;EACpF,oCAAoC;EACpC,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,oCAAoC;EACpC,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,WAAS;EACT,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,oCAAoC;EACpC,0BAA0B;EAC1B,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;;+DAE+D;;AAE/D;;;EAGE,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;;;EAGE,iCAAiC;EACjC,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA,8BAA8B;AAC9B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,cAAc;EACd,yCAAyC;EACzC,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,aAAa;EACb,yBAAyB;AAC3B;;AAEA,wCAAwC,cAAc,EAAE;AACxD,yCAAyC,cAAc,EAAE;AACzD,sCAAsC,cAAc,EAAE;;AAEtD;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,uEAAuE;AACzE;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,UAAU;EACV,8CAA8C;AAChD;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,wFAAwF;EACxF,qCAAqC;AACvC;;AAEA;EACE,0EAA0E;EAC1E,aAAa;AACf;;AAEA;EACE,yFAAyF;EACzF,sCAAsC;AACxC;;AAEA;EACE,0EAA0E;EAC1E,aAAa;AACf;;AAEA;EACE,wFAAwF;EACxF,oCAAoC;AACtC;;AAEA;EACE,yFAAyF;EACzF,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,qCAAqC;AACrC;EACE,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,qCAAqC;EACrC,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,4BAA4B;EAC5B,wDAAwD;AAC1D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,+FAA+F;AACjG;;AAEA;EACE,qCAAqC;EACrC,+FAA+F;AACjG;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;EAC7B,0BAA0B;EAC1B,iDAAiD;AACnD;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;AACA,qEAAqE;AACrE;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;;EAEE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA,8CAA8C;AAC9C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* User Details Page - Compact Modern Design */\n.user-details-page {\n  position: relative;\n  padding: 1.25rem 1.5rem 2rem;\n  max-width: 1400px;\n  margin: 0 auto;\n  min-height: calc(100vh - 80px);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--text-primary);\n}\n\n/* Navigation Tabs */\n.user-details-nav {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 32px;\n  padding: 8px;\n  background: var(--bg-primary);\n  border-radius: 16px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);\n  border: none;\n}\n\n.nav-tab {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: transparent;\n  border: none;\n  border-radius: 8px;\n  position: relative;\n  overflow: hidden;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  font-family: inherit;\n}\n\n.nav-tab:hover:not(.active) {\n  background: var(--nav-hover-bg);\n  color: var(--text-primary);\n}\n\n.nav-tab.active {\n  color: white;\n}\n\n.profile-nav-active-bg {\n  position: absolute;\n  inset: 0;\n  background: var(--accent-primary);\n  border-radius: 8px;\n  box-shadow: var(--shadow-sm);\n  z-index: 0;\n  pointer-events: none;\n}\n\n.nav-tab-content {\n  position: relative;\n  z-index: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n/* Unified Button Styles */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border: none;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  text-decoration: none;\n  font-family: inherit;\n}\n\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background: var(--accent-primary);\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  background: var(--accent-hover);\n  box-shadow: var(--shadow-md);\n}\n\n.btn-secondary {\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: var(--nav-hover-bg);\n  border-color: var(--accent-primary);\n}\n\n.btn-back {\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n}\n\n.btn-back:hover {\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n\n.btn-icon {\n  padding: 6px 10px;\n  background: var(--nav-hover-bg);\n  border: 1px solid var(--border-color);\n  font-size: 1rem;\n}\n\n.btn-icon:hover:not(:disabled) {\n  background: var(--nav-hover-bg);\n}\n\n.btn-copy {\n  padding: 4px 8px;\n  background: var(--nav-hover-bg);\n  color: var(--text-secondary);\n  font-size: 0.75rem;\n  margin-left: 8px;\n}\n\n.btn-copy:hover {\n  background: var(--nav-hover-bg);\n}\n\n.btn-danger {\n  background: #ef4444;\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n\n.btn-danger:hover:not(:disabled) {\n  transform: translateY(-1px);\n  background: #dc2626;\n  box-shadow: var(--shadow-md);\n}\n\n.btn-danger-sm {\n  padding: 6px 12px;\n  font-size: 0.8125rem;\n  background: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n  border: 1px solid rgba(239, 68, 68, 0.2);\n}\n\n.btn-danger-sm:hover {\n  background: rgba(239, 68, 68, 0.2);\n}\n\n.btn-action {\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n  padding: 12px 16px;\n  justify-content: flex-start;\n}\n\n.btn-action:hover {\n  background: var(--nav-hover-bg);\n  border-color: var(--accent-primary);\n  transform: translateX(4px);\n}\n\n.tab-content {\n  animation: fadeInTab 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@keyframes fadeInTab {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n/* Main Grid Layout */\n.user-details-main-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n}\n\n/* Card Styles */\n.details-card {\n  background: var(--bg-primary);\n  border-radius: 20px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.04);\n  border: none;\n  overflow: hidden;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  overflow-anchor: none;\n}\n\n.details-card:hover {\n  box-shadow: 0 12px 48px rgba(37, 99, 235, 0.12);\n  transform: translateY(-4px);\n}\n\n.card-full {\n  grid-column: span 2;\n}\n\n.card-half {\n  grid-column: span 1;\n}\n\n.card-header {\n  padding: 16px 20px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.04);\n  background: transparent;\n}\n\n.card-title {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.card-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--accent-primary);\n  flex-shrink: 0;\n  line-height: 0;\n}\n\n.card-icon svg {\n  display: block;\n}\n\n.card-icon-circle {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: rgba(37, 99, 235, 0.08);\n  /* Slightly lighter */\n  border: 1px solid rgba(59, 130, 246, 0.2);\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  overflow: hidden;\n  flex-shrink: 0;\n  color: var(--accent-primary);\n  line-height: 0;\n}\n\n.card-icon-circle .custom-icon {\n  width: 13px !important;\n  height: 13px !important;\n  display: block;\n  margin: 0;\n}\n\n.card-content {\n  padding: 20px;\n}\n\n/* Profile Header */\n.profile-header {\n  display: flex;\n  gap: 24px;\n  align-items: center;\n}\n\n.profile-avatar {\n  width: 96px;\n  height: 96px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 4px solid var(--bg-primary);\n  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.2);\n  flex-shrink: 0;\n}\n\n.profile-avatar-placeholder {\n  width: 96px;\n  height: 96px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 2.5rem;\n  flex-shrink: 0;\n  border: 4px solid var(--bg-primary);\n  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.2);\n}\n\n.profile-info {\n  flex: 1;\n}\n\n.profile-name-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 8px;\n  flex-wrap: wrap;\n}\n\n.profile-name {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  letter-spacing: -0.015em;\n}\n\n.plan-badge {\n  padding: 4px 12px;\n  border-radius: 99px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.plan-badge.basic {\n  background: rgba(148, 163, 184, 0.12);\n  color: #64748b;\n  border: 1px solid rgba(148, 163, 184, 0.2);\n}\n\n.plan-badge.pro {\n  background: rgba(245, 158, 11, 0.1);\n  color: #d97706;\n  border: 1px solid rgba(245, 158, 11, 0.2);\n}\n\n.plan-badge.premium {\n  background: rgba(139, 92, 246, 0.1);\n  color: #7c3aed;\n  border: 1px solid rgba(139, 92, 246, 0.2);\n}\n\n.plan-badge.master {\n  background: rgba(239, 68, 68, 0.1);\n  color: #dc2626;\n  border: 1px solid rgba(239, 68, 68, 0.2);\n}\n\n.plan-badge.vip {\n  background: linear-gradient(135deg, rgba(251, 191, 36, 0.15), rgba(245, 158, 11, 0.15));\n  color: #b45309;\n  border: 1px solid rgba(245, 158, 11, 0.3);\n}\n\n.status-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Order details sidebar: крупнее бейдж статуса, вкладки выше тегов */\n.order-sidebar-status-wrap {\n  justify-content: center;\n  margin-top: 4px;\n}\n\n.order-sidebar-status-badge.status-badge {\n  padding: 0.55rem 1.2rem !important;\n  font-size: 0.875rem !important;\n  border-radius: 10px !important;\n}\n\n.order-sidebar-tabs {\n  margin-top: 16px;\n}\n\n.order-sidebar-tags-block {\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n[data-theme='dark'] .order-sidebar-tags-block {\n  border-top-color: rgba(255, 255, 255, 0.08);\n}\n\n.btn-edit-user {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  font-size: 0.85rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 100%;\n  margin-top: 8px;\n}\n\n.btn-edit-user:hover {\n  background: var(--nav-hover-bg);\n  border-color: #cbd5e1;\n  color: var(--accent-primary);\n}\n\n.btn-edit-user:active {\n  transform: translateY(0);\n}\n\n/* Status badge styles moved to status-badge.css */\n\n.profile-meta {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n  flex-wrap: wrap;\n}\n\n.balance {\n  font-weight: 600;\n  color: #10b981;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.btn-edit-balance {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: var(--text-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  border-radius: 6px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.btn-edit-balance:hover {\n  background: var(--nav-hover-bg);\n  color: var(--text-primary);\n  transform: scale(1.05);\n}\n\n/* Info Rows */\n.info-row {\n  display: flex;\n  align-items: baseline;\n  padding-bottom: 8px;\n  margin-bottom: 8px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.02);\n}\n\n.info-row:last-child {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.info-label {\n  width: 140px;\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  font-weight: 600;\n  flex-shrink: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.info-value {\n  color: var(--text-primary);\n  font-weight: 500;\n  font-size: 0.875rem;\n  word-break: break-word;\n  flex: 1;\n}\n\n.info-value.highlight {\n  color: #10b981;\n  font-weight: 700;\n}\n\n.info-value.mono {\n  font-family: 'SF Mono', 'Courier New', Courier, monospace;\n  background: var(--nav-hover-bg);\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 0.8125rem;\n  display: inline-flex;\n  align-items: center;\n  border: 1px solid var(--border-color);\n}\n\n.btn-copy {\n  padding: 4px;\n  margin-left: 8px;\n  background: transparent;\n  color: var(--text-secondary);\n  border: none;\n  cursor: pointer;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.btn-copy:hover {\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n\n/* Address */\n.address-badge {\n  display: inline-block;\n  background: var(--nav-active-bg);\n  color: var(--nav-active-color);\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.address-info {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 0.875rem;\n}\n\n.address-secondary {\n  color: var(--text-secondary);\n  font-size: 0.8125rem;\n}\n\n/* Reviews Container */\n.reviews-container {\n  background: var(--bg-primary);\n  border-radius: 20px;\n  padding: 24px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.04);\n  border: none;\n}\n\n.reviews-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.reviews-header h2 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.reviews-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.review-card {\n  background: var(--bg-primary);\n  border-radius: 16px;\n  padding: 20px;\n  border: 1px solid rgba(0, 0, 0, 0.03);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.02);\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.review-card:hover {\n  border-color: rgba(37, 99, 235, 0.15);\n  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.08);\n  transform: translateY(-2px);\n}\n\n.review-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.reviewer-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.reviewer-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid var(--border-color);\n}\n\n.reviewer-avatar-placeholder {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: var(--accent-primary);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 1rem;\n}\n\n.reviewer-name {\n  font-weight: 600;\n  color: var(--text-primary);\n  font-size: 0.95rem;\n}\n\n.review-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.review-rating {\n  font-size: 0.8125rem;\n  color: var(--text-secondary);\n}\n\n.review-plan {\n  padding: 2px 8px;\n  border-radius: 8px;\n  font-size: 0.65rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.review-plan.basic {\n  background: var(--nav-hover-bg);\n  color: var(--text-primary);\n}\n\n.review-plan.pro {\n  background: rgba(245, 158, 11, 0.1);\n  color: #f59e0b;\n}\n\n.review-date {\n  font-size: 0.8125rem;\n  color: var(--text-secondary);\n}\n\n.review-content {\n  position: relative;\n}\n\n.review-content p {\n  margin: 0;\n  padding-right: 96px;\n  color: var(--text-primary);\n  font-size: 0.875rem;\n  line-height: 1.6;\n}\n\n.review-actions {\n  position: absolute;\n  top: 0;\n  right: 0;\n  display: inline-flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.review-actions .btn-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n}\n\n/* Interaction Container */\n.interaction-container {\n  background: var(--bg-primary);\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);\n  border: 1px solid var(--border-color);\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.interaction-section h2 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 16px 0;\n}\n\n.note-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.note-textarea {\n  width: 100%;\n  padding: 14px;\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  font-size: 0.875rem;\n  font-family: inherit;\n  resize: vertical;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.note-textarea:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);\n}\n\n.note-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.user-comments-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-top: 16px;\n  margin-bottom: 8px;\n}\n\n.user-comment-card {\n  border-radius: 12px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);\n  overflow: hidden;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.user-comment-card:hover {\n  border-color: var(--accent-primary);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);\n  transform: translateY(-2px);\n}\n\n.user-comment-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 16px;\n  background: var(--bg-primary);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.user-comment-card-author {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.user-comment-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: var(--accent-primary);\n  color: #fff;\n  font-size: 0.95rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.user-comment-card-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.user-comment-card-name {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.user-comment-role {\n  padding: 2px 8px;\n  border-radius: 6px;\n  background: rgba(139, 92, 246, 0.1);\n  color: var(--accent-primary);\n  font-size: 0.7rem;\n  font-weight: 600;\n  width: fit-content;\n}\n\n.user-comment-card-date {\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n  white-space: nowrap;\n}\n\n.user-comment-card-body {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 16px;\n  background: var(--bg-primary);\n}\n\n.user-comment-card-text {\n  flex: 1;\n  min-width: 0;\n  font-size: 0.9rem;\n  line-height: 1.6;\n  color: var(--text-primary);\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.user-comment-card-actions {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  flex-shrink: 0;\n  padding-top: 2px;\n}\n\n.user-comment-card-actions .btn-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n}\n\n.user-comment-card .user-comment-edit {\n  padding: 16px;\n  border-top: 1px solid var(--border-color);\n  background: var(--bg-primary);\n}\n\n.user-comment-card .user-comment-edit .note-textarea {\n  margin-bottom: 12px;\n}\n\n.user-comment-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.btn-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  color: var(--text-secondary);\n  cursor: pointer;\n  border-radius: 6px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.btn-icon:hover {\n  background: var(--nav-hover-bg);\n  color: var(--text-primary);\n  transform: translateY(-1px);\n}\n\n.btn-icon.danger {\n  color: #ef4444;\n}\n\n.btn-icon.danger:hover {\n  background: rgba(239, 68, 68, 0.1);\n  color: #dc2626;\n}\n\n.btn-xs {\n  padding: 4px 8px;\n  font-size: 0.8rem;\n}\n\n.user-comment-edit {\n  margin-top: 4px;\n}\n\n.status-inline {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 8px;\n}\n\n.btn-status {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  color: var(--text-primary);\n  justify-content: flex-start;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.btn-status:hover {\n  background: var(--nav-hover-bg);\n  border-color: var(--accent-primary);\n}\n\n.btn-status .order-status-icon {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-secondary);\n}\n\n.btn-status[data-order-status='DONE'] .order-status-icon {\n  color: #10b981;\n}\n\n.btn-status[data-order-status='DONE_DELETED'] .order-status-icon {\n  color: #10b981;\n  opacity: 0.6;\n}\n\n.btn-status[data-order-status='CANCELED'] .order-status-icon {\n  color: #64748b;\n}\n\n.btn-status[data-order-status='BLOCKED'] .order-status-icon {\n  color: #ef4444;\n}\n\n.btn-status.active {\n  border-color: var(--accent-primary);\n  box-shadow: var(--shadow-sm);\n  background: rgba(139, 92, 246, 0.1);\n  color: var(--accent-primary);\n}\n\n/* Message Toast */\n.message-toast {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  padding: 12px 16px;\n  border-radius: 10px;\n  background: white;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  z-index: 2000;\n  animation: slideIn 0.3s ease;\n  border-left: 4px solid;\n  max-width: 320px;\n  font-size: 0.875rem;\n}\n\n.message-toast.success {\n  border-left-color: #10b981;\n}\n\n.message-toast.error {\n  border-left-color: #ef4444;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.message-close {\n  background: none;\n  border: none;\n  font-size: 1.25rem;\n  color: #94a3b8;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n  margin-left: auto;\n}\n\n.message-close:hover {\n  color: var(--text-secondary);\n}\n\n/* Modal */\n.user-details-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(15, 23, 42, 0.42);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3000;\n  animation: fadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Keep the same blur on edit/status overlays too */\n.user-details-modal-overlay.user-edit-overlay {\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  background: rgba(15, 23, 42, 0.48);\n}\n\n.user-details-modal-overlay.transparent {\n  background: rgba(0, 0, 0, 0.2);\n  backdrop-filter: none;\n}\n\n/* Balance modal: open higher and use available width */\n.user-details-modal-overlay.balance-modal-overlay {\n  align-items: flex-start;\n  padding: clamp(14px, 6vh, 56px) 16px 24px;\n  overflow-y: auto;\n}\n\n.user-details-modal-content {\n  background: var(--bg-primary);\n  border-radius: 20px;\n  max-width: 400px;\n  width: 90%;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n  border: 1px solid var(--border-color);\n  overflow: hidden;\n  animation: slideUp 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  overscroll-behavior: contain;\n  overflow-anchor: none;\n}\n\n/* Balance modal — match user-edit-modal design */\n.user-details-modal-content.balance-modal {\n  max-width: min(560px, calc(100vw - 32px));\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  border-radius: 16px;\n  overflow: visible;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.22);\n  margin: 0 auto;\n  max-height: calc(100vh - clamp(38px, 10vh, 96px));\n}\n\n.balance-modal .modal-header {\n  flex-shrink: 0;\n  padding: 16px 20px;\n  background: transparent;\n  border-bottom: 1px solid var(--border-color);\n  border-radius: 16px 16px 0 0;\n}\n\n.balance-modal .modal-header h3 {\n  margin: 0;\n  font-size: 1.12rem;\n  font-weight: 800;\n  color: var(--text-primary);\n  letter-spacing: -0.01em;\n}\n\n.balance-modal .modal-body {\n  flex: 1 1 0;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 14px 22px 10px;\n  background: transparent;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.balance-modal .balance-form,\n.balance-modal .balance-form .form-group {\n  width: 100%;\n  min-width: 0;\n  align-self: stretch;\n}\n\n.balance-modal .form-input,\n.balance-modal .form-textarea,\n.balance-modal textarea.form-input,\n.balance-modal .reason-textarea {\n  max-width: 100%;\n  margin-left: 0;\n  margin-right: 0;\n  display: block;\n  padding: 10px 12px;\n  text-align: left;\n}\n\n.balance-modal .modal-actions {\n  flex-shrink: 0;\n  background: var(--bg-primary);\n  border-top: 1px solid var(--border-color);\n  padding: 12px 22px 14px;\n  display: flex;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  gap: 12px;\n  border-radius: 0 0 16px 16px;\n}\n\n.balance-modal .btn {\n  border-radius: 12px;\n  padding: 10px 16px;\n  min-width: 0;\n  flex: 1 1 calc(50% - 6px);\n  max-width: 100%;\n}\n\n.balance-modal .modal-actions .btn-secondary {\n  border: 1px solid rgba(148, 163, 184, 0.35);\n}\n\n.balance-modal .modal-actions .btn-primary {\n  box-shadow: 0 12px 30px rgba(59, 130, 246, 0.18);\n}\n\n.balance-modal .form-input:focus,\n.balance-modal .form-textarea:focus,\n.balance-modal .reason-textarea:focus {\n  border-color: rgba(59, 130, 246, 0.85);\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.12);\n}\n\n/* Balance type selector — two side-by-side toggle buttons */\n.balance-type-selector {\n  display: flex;\n  gap: 8px;\n}\n\n.type-btn {\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 11px 16px;\n  border: 1.5px solid var(--border-color);\n  background: var(--bg-primary);\n  border-radius: 12px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  font-family: inherit;\n}\n\n.type-btn:hover {\n  border-color: var(--accent-primary);\n  background: var(--nav-hover-bg);\n  color: var(--text-primary);\n}\n\n.type-btn.active {\n  border-color: var(--accent-primary);\n  background: var(--accent-primary);\n  color: #fff;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);\n}\n\n.type-btn.add.active {\n  background: var(--accent-primary);\n  border-color: var(--accent-primary);\n}\n\n.type-btn.subtract.active {\n  background: #ef4444;\n  border-color: #ef4444;\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.25);\n}\n\n/* Current balance card display */\n.current-balance-display {\n  padding: 14px 18px;\n  background: rgba(16, 185, 129, 0.08);\n  border: 1px solid rgba(16, 185, 129, 0.2);\n  border-radius: 12px;\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: #059669;\n  font-family: var(--font-data, 'Fira Code', monospace);\n  letter-spacing: 0.02em;\n}\n\n/* Reason textarea */\n.reason-textarea {\n  min-height: 80px;\n  resize: vertical;\n  padding: 12px 16px;\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  font-size: 0.95rem;\n  font-family: inherit;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n\n/* Field error message */\n.field-error {\n  color: #ef4444;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  margin-top: -2px;\n}\n\n/* Confirmation details */\n.balance-confirmation-details {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.conf-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 10px 16px;\n  background: var(--bg-secondary);\n  border-radius: 10px;\n  border: 1px solid var(--border-color);\n}\n\n.conf-label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.conf-value {\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  text-align: right;\n  max-width: 60%;\n  word-break: break-word;\n}\n\n.conf-value.text-success { color: #10b981; }\n.conf-value.text-danger { color: #ef4444; }\n\n/* Balance preview card in confirmation */\n.balance-preview-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  background: rgba(59, 130, 246, 0.06);\n  border: 1px solid rgba(59, 130, 246, 0.15);\n  border-radius: 12px;\n  margin-top: 4px;\n}\n\n.preview-item {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  text-align: center;\n}\n\n.preview-item span:first-child {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.preview-item span:last-child {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  font-family: var(--font-data, 'Fira Code', monospace);\n}\n\n.preview-separator {\n  color: var(--text-secondary);\n  opacity: 0.5;\n  display: flex;\n  align-items: center;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.user-details-modal-content .modal-header {\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--border-color);\n  background: transparent;\n}\n\n.user-details-modal-content .modal-header h3 {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.user-details-modal-content .modal-body {\n  padding: 24px;\n}\n\n.user-details-modal-content .modal-body p {\n  margin: 0 0 16px 0;\n  color: var(--text-secondary);\n  font-size: 0.95rem;\n  line-height: 1.6;\n}\n\n.user-details-modal-content .modal-body p:last-child {\n  margin-bottom: 0;\n}\n\n.warning-text {\n  color: #ef4444;\n  font-weight: 600;\n}\n\n.user-details-modal-content .modal-actions {\n  padding: 16px 24px;\n  border-top: 1px solid var(--border-color);\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  background: var(--bg-primary);\n}\n\n/* Loading/Empty States */\n.loading-state,\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  text-align: center;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid var(--border-color);\n  border-top: 3px solid var(--accent-primary);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 16px;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.empty-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 16px;\n  color: var(--accent-primary);\n  opacity: 0.8;\n}\n\n.empty-state h3 {\n  margin: 0 0 8px 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.empty-state p {\n  margin: 0;\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .card-half {\n    grid-column: span 2;\n  }\n\n  .quick-actions {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .user-details-page {\n    padding: 8px;\n    margin-top: 8px;\n  }\n\n  .user-details-nav {\n    flex-direction: column;\n  }\n\n  .nav-tab {\n    width: 100%;\n  }\n\n  .user-details-main-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .card-full,\n  .card-half {\n    grid-column: span 1;\n  }\n\n  .profile-header {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .profile-name-row {\n    justify-content: center;\n  }\n\n  .profile-meta {\n    justify-content: center;\n  }\n\n  .status-menu {\n    width: 100%;\n    right: -100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .filter-row {\n    grid-template-columns: 1fr;\n  }\n\n  .user-details-modal-content {\n    width: 95%;\n  }\n\n  .user-details-modal-content .modal-actions {\n    flex-direction: column;\n  }\n\n  .user-details-modal-content .btn {\n    width: 100%;\n  }\n}\n\n/* Balance Change Modal */\n.balance-modal {\n  max-width: 500px;\n}\n\n/* User Edit Modal — ограничение по высоте экрана и прокрутка формы */\n.user-edit-modal {\n  max-width: 600px;\n  max-height: 96vh;\n  display: flex;\n  flex-direction: column;\n  border-radius: 16px;\n  overflow: visible;\n}\n\n.user-edit-modal.modal-content {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.22);\n  transform: translateY(-3px);\n  overflow: visible;\n  border-radius: 16px;\n}\n\n.user-edit-modal .modal-header {\n  flex-shrink: 0;\n  padding: 16px 16px;\n  background: transparent;\n  border-bottom: 1px solid var(--border-color);\n  border-radius: 16px 16px 0 0;\n  box-sizing: border-box;\n}\n\n.user-edit-modal-title-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.user-edit-modal-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 12px;\n  background: var(--nav-hover-bg);\n  border: 1px solid var(--border-color);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-primary);\n  flex-shrink: 0;\n}\n\n.user-edit-modal .modal-header h3 {\n  margin: 0;\n  font-size: 1.12rem;\n  font-weight: 800;\n  color: var(--text-primary);\n  letter-spacing: -0.01em;\n}\n\n.user-edit-modal .modal-body {\n  flex: 1 1 0;\n  min-height: 0;\n  overflow: visible;\n  /* Компактные симметричные отступы — поля совпадают с краем заголовка */\n  padding: 12px 16px 14px;\n  background: transparent;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  box-sizing: border-box;\n}\n\n.user-edit-modal .modal-actions {\n  flex-shrink: 0;\n  background: var(--bg-primary);\n  border-top: 1px solid var(--border-color);\n  padding: 12px 16px 14px;\n  display: flex;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  gap: 12px;\n  border-radius: 0 0 16px 16px;\n  box-sizing: border-box;\n}\n\n.user-edit-modal .form-group {\n  gap: 6px;\n  min-width: 0;\n  width: 100%;\n  align-items: stretch;\n}\n\n/* CustomSelect в модалке: обёртка inline-block иначе сужает ряд и визуально смещает сетку */\n.user-edit-modal .form-group > .sort-menu-wrapper {\n  display: block;\n  width: 100%;\n  min-width: 0;\n}\n\n.user-edit-modal .form-group .sort-menu-button {\n  width: 100%;\n  min-width: 0 !important;\n  box-sizing: border-box;\n}\n\n.user-edit-modal .form-label {\n  font-weight: 700;\n  margin: 0;\n  padding: 0;\n  text-align: left;\n  align-self: flex-start;\n  width: 100%;\n}\n\n.user-edit-modal .form-input,\n.user-edit-modal .form-textarea,\n.user-edit-modal textarea.form-input {\n  background: var(--bg-primary);\n  border-color: var(--border-color);\n  max-width: 100%;\n  /* Компактный внутренний отступ — текст не «уезжает» от левого края */\n  padding: 10px 12px;\n  text-indent: 0;\n  text-align: left;\n}\n\n.user-edit-modal .form-input:focus,\n.user-edit-modal .form-textarea:focus {\n  border-color: rgba(59, 130, 246, 0.85);\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.12);\n}\n\n.user-edit-modal .btn {\n  border-radius: 12px;\n  padding: 10px 16px;\n  min-width: 0;\n  flex: 1 1 calc(50% - 6px);\n  max-width: 100%;\n}\n\n@media (max-width: 480px) {\n  .user-edit-modal .btn {\n    width: 100%;\n    flex: 1 1 100%;\n    min-width: 0;\n  }\n}\n\n.user-edit-modal .modal-actions .btn-secondary {\n  border: 1px solid rgba(148, 163, 184, 0.35);\n}\n\n.user-edit-modal .modal-actions .btn-primary {\n  box-shadow: 0 12px 30px rgba(59, 130, 246, 0.18);\n}\n\n.edit-user-form {\n  display: grid;\n  /* minmax(0,1fr) — иначе min-width:auto у колонок раздувает сетку и смещает поля вправо */\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.edit-user-form .form-group.full-width {\n  grid-column: span 2;\n  min-width: 0;\n}\n\n/* Модалка: плотная сетка без смещения колонок */\n.user-edit-modal .edit-user-form {\n  gap: 12px;\n  min-width: 0;\n  width: 100%;\n  box-sizing: border-box;\n  justify-items: stretch;\n}\n\n.status-preview {\n  padding: 12px 16px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  font-size: 0.95rem;\n  color: var(--text-primary);\n  font-weight: 600;\n}\n\n.balance-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.form-input,\n.form-textarea {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 12px 16px;\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  font-size: 0.95rem;\n  font-family: inherit;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n\n.form-input:focus,\n.form-textarea:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);\n}\n\n.form-input.error,\n.form-textarea.error {\n  border-color: #ef4444;\n}\n\n.form-error {\n  color: #ef4444;\n  font-size: 0.8125rem;\n  margin-top: -4px;\n}\n\n.balance-display {\n  padding: 12px 16px;\n  background: var(--nav-hover-bg);\n  border-radius: 12px;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #10b981;\n  text-align: center;\n}\n\n.balance-type-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.btn-balance-type {\n  flex: 1;\n  padding: 12px 16px;\n  border: 1px solid var(--border-color);\n  background: var(--bg-primary);\n  border-radius: 12px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.btn-balance-type:hover {\n  border-color: var(--accent-primary);\n  background: var(--nav-hover-bg);\n  color: var(--text-primary);\n}\n\n.btn-balance-type.active {\n  border-color: var(--accent-primary);\n  background: var(--accent-primary);\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n\n.balance-preview {\n  padding: 16px;\n  background: rgba(16, 185, 129, 0.1);\n  border: 1px solid #34d399;\n  border-radius: 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.balance-preview-label {\n  font-size: 0.95rem;\n  color: #065f46;\n  font-weight: 600;\n}\n\n.balance-preview-value {\n  font-size: 1.25rem;\n  color: #059669;\n  font-weight: 700;\n}\n\n.balance-preview.warning {\n  background: rgba(239, 68, 68, 0.1);\n  border-color: #f87171;\n}\n\n.balance-preview.warning .balance-preview-label {\n  color: #991b1b;\n}\n\n.balance-preview.warning .balance-preview-value {\n  color: #dc2626;\n}\n\n.balance-warning-text {\n  font-size: 0.8125rem;\n  color: #ef4444;\n  font-weight: 600;\n}\n\n.balance-confirm {\n  text-align: center;\n}\n\n.confirm-icon {\n  font-size: 3.5rem;\n  margin-bottom: 16px;\n  color: var(--accent-primary);\n  display: flex;\n  justify-content: center;\n}\n\n.confirm-text {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 24px;\n}\n\n.confirm-details {\n  background: var(--bg-primary);\n  border-radius: 12px;\n  padding: 20px;\n  text-align: left;\n  border: 1px solid var(--border-color);\n}\n\n.confirm-detail-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.confirm-detail-row:last-child {\n  border-bottom: none;\n}\n\n.confirm-detail-label {\n  font-size: 0.95rem;\n  color: var(--text-secondary);\n  font-weight: 600;\n}\n\n.confirm-detail-value {\n  font-size: 0.95rem;\n  color: var(--text-primary);\n  font-weight: 700;\n  text-align: right;\n  max-width: 60%;\n  word-break: break-word;\n}\n\n.confirm-detail-value.highlight {\n  color: #10b981;\n  font-size: 1.1rem;\n}\n\n.loading-spinner-small {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top: 2px solid white;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  margin-right: 8px;\n}\n\n/* Company Portfolio Styles - Compact */\n.compact-list {\n  padding: 8px 0;\n}\n\n/* Compact Categories */\n.categories-compact {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.category-compact {\n  padding: 6px 8px;\n  background: var(--bg-primary);\n  border-radius: 4px;\n  border: 1px solid var(--border-color);\n}\n\n.category-title-small {\n  font-weight: 600;\n  color: var(--text-primary);\n  font-size: 0.8125rem;\n  display: block;\n  margin-bottom: 3px;\n}\n\n.category-tags-compact {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3px;\n}\n\n.category-tag-small {\n  padding: 1px 6px;\n  background: #e0e7ff;\n  color: #4338ca;\n  border-radius: 10px;\n  font-size: 0.6875rem;\n  font-weight: 500;\n}\n\n.category-tag-more {\n  padding: 1px 6px;\n  background: #cbd5e1;\n  color: var(--text-secondary);\n  border-radius: 10px;\n  font-size: 0.6875rem;\n  font-weight: 500;\n}\n\n/* Simple Categories List */\n.categories-list-simple {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.category-item-simple {\n  padding: 8px 12px;\n  background: var(--bg-primary);\n  border-radius: 6px;\n  border: 1px solid var(--border-color);\n  color: var(--text-primary);\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.category-item-simple:hover {\n  background: var(--nav-hover-bg);\n  border-color: #cbd5e1;\n}\n\n/* Compact Regions */\n.regions-compact {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.region-badge {\n  padding: 4px 10px;\n  background: var(--nav-hover-bg);\n  color: var(--text-secondary);\n  border-radius: 12px;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  border: 1px solid var(--border-color);\n}\n\n/* Regions Inline */\n.regions-inline {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px;\n  line-height: 1.6;\n}\n\n.region-inline {\n  color: var(--text-primary);\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.region-separator {\n  margin-left: 2px;\n  color: var(--text-secondary);\n}\n\n/* Compact Services */\n.services-compact {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  gap: 12px;\n  padding: 8px 0;\n}\n\n.service-compact {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px;\n  background: var(--bg-primary);\n  border-radius: 12px;\n  border: 1px solid var(--border-color);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.service-compact:hover {\n  border-color: var(--accent-primary);\n  box-shadow: var(--shadow-sm);\n  transform: translateY(-2px);\n  background: var(--bg-secondary);\n}\n\n.service-name-small {\n  font-weight: 500;\n  color: var(--text-primary);\n  font-size: 0.875rem;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-right: 16px;\n  line-height: 1.5;\n}\n\n.service-price-small {\n  font-weight: 600;\n  color: var(--accent-primary);\n  font-size: 0.875rem;\n  flex-shrink: 0;\n  padding: 4px 12px;\n  background: rgba(139, 92, 246, 0.1);\n  border-radius: 8px;\n  white-space: nowrap;\n}\n\n/* Compact Documents */\n.documents-compact {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.document-compact {\n  padding: 5px 8px;\n  background: var(--bg-primary);\n  border-radius: 4px;\n  border: 1px solid var(--border-color);\n}\n\n.document-link-small {\n  color: #2563eb;\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 0.8125rem;\n  transition: color 0.2s ease;\n  display: block;\n}\n\n.document-link-small:hover {\n  color: #1d4ed8;\n  text-decoration: underline;\n}\n\n/* Compact Photos */\n.photos-compact {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));\n  gap: 6px;\n}\n\n.photo-compact {\n  position: relative;\n  aspect-ratio: 1;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 1px solid var(--border-color);\n}\n\n.photo-thumbnail-small {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.2s ease;\n}\n\n.photo-compact:hover .photo-thumbnail-small {\n  transform: scale(1.05);\n}\n\n.photo-placeholder-small {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--nav-hover-bg);\n  color: var(--text-secondary);\n  font-size: 1.5rem;\n}\n\n/* Styled Photos Grid */\n.photos-grid-styled {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n  gap: 16px;\n  padding: 8px 0;\n  contain: layout style;\n}\n\n.photo-item-styled {\n  position: relative;\n  aspect-ratio: 1;\n  border-radius: 12px;\n  overflow: hidden;\n  border: 1px solid var(--border-color);\n  background: var(--bg-primary);\n  box-shadow: var(--shadow-sm);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  contain: layout;\n}\n\n.photo-item-styled:hover {\n  border-color: var(--accent-primary);\n  box-shadow: var(--shadow-md);\n  transform: translateY(-4px);\n}\n\n/* .photo-link — это <button>, открывающий просмотрщик, поэтому сбрасываем стили кнопки */\n.photo-link {\n  display: block;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font: inherit;\n  color: inherit;\n}\n\n.photo-link:focus-visible {\n  outline: 2px solid var(--accent-primary);\n  outline-offset: -2px;\n}\n\n/* Кнопка «Ещё N» / «Свернуть» под сеткой фото */\n.photos-toggle-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 10px;\n  padding: 7px 14px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  background: var(--bg-primary);\n  color: var(--text-secondary);\n  font-size: 0.8125rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.photos-toggle-btn:hover {\n  border-color: var(--accent-primary);\n  color: var(--text-primary);\n  background: var(--nav-hover-bg);\n}\n\n.photo-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.photo-link:hover .photo-image {\n  transform: scale(1.08);\n}\n\n.photo-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  backdrop-filter: blur(2px);\n}\n\n.photo-link:hover .photo-overlay {\n  opacity: 1;\n}\n\n.photo-icon {\n  font-size: 2rem;\n  color: white;\n  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.4));\n  transform: translateY(10px);\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.photo-link:hover .photo-icon {\n  transform: translateY(0);\n}\n\n.photo-placeholder-styled {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: var(--nav-hover-bg);\n  color: var(--text-secondary);\n  gap: 8px;\n}\n\n.photo-placeholder-icon {\n  font-size: 2rem;\n  color: var(--accent-primary);\n  opacity: 0.8;\n}\n\n.photo-placeholder-text {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n/* Legacy styles for backward compatibility */\n.categories-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.category-item {\n  padding: 8px 12px;\n  background: var(--bg-primary);\n  border-radius: 6px;\n  border: 1px solid var(--border-color);\n}\n\n.category-title {\n  font-weight: 600;\n  color: var(--text-primary);\n  display: block;\n  margin-bottom: 4px;\n}\n\n.category-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 4px;\n}\n\n.category-tag {\n  padding: 2px 8px;\n  background: #e0e7ff;\n  color: #4338ca;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.regions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.region-item {\n  padding: 6px 10px;\n  background: var(--bg-primary);\n  border-radius: 6px;\n  border: 1px solid var(--border-color);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.region-name {\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.region-code {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n}\n\n.services-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.service-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 12px;\n  background: var(--bg-primary);\n  border-radius: 6px;\n  border: 1px solid var(--border-color);\n}\n\n.service-name {\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.service-price {\n  font-weight: 600;\n  color: #059669;\n}\n\n.documents-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.document-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  background: var(--bg-primary);\n  border-radius: 6px;\n  border: 1px solid var(--border-color);\n}\n\n.document-link {\n  color: #2563eb;\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.2s ease;\n}\n\n.document-link:hover {\n  color: #1d4ed8;\n  text-decoration: underline;\n}\n\n.document-size {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  margin-left: auto;\n}\n\n.photos-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n  gap: 12px;\n}\n\n.photo-item {\n  position: relative;\n  aspect-ratio: 1;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid var(--border-color);\n}\n\n.photo-thumbnail {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.2s ease;\n}\n\n.photo-item:hover .photo-thumbnail {\n  transform: scale(1.05);\n}\n\n.photo-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--nav-hover-bg);\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n}\n\n/* Schedule Display Styles */\n.schedule-display-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n  border-bottom: 1px dashed var(--border-color);\n}\n\n.schedule-display-wrapper:last-child {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.schedule-display {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 4px;\n}\n\n.schedule-day {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  background: var(--bg-primary);\n  border-radius: 8px;\n  border: 1px solid var(--border-color);\n  font-size: 0.875rem;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.schedule-day:hover {\n  background: var(--nav-hover-bg);\n  border-color: var(--accent-primary);\n  transform: translateX(4px);\n}\n\n.schedule-day-name {\n  font-weight: 600;\n  color: var(--text-primary);\n  min-width: 100px;\n  flex-shrink: 0;\n}\n\n.schedule-day-off {\n  color: #ef4444;\n  font-weight: 600;\n  font-size: 0.75rem;\n  padding: 4px 10px;\n  background: rgba(239, 68, 68, 0.1);\n  border-radius: 12px;\n}\n\n.schedule-flexible {\n  color: var(--accent-primary);\n  font-weight: 600;\n  font-size: 0.75rem;\n  padding: 4px 10px;\n  background: rgba(139, 92, 246, 0.1);\n  border-radius: 12px;\n}\n\n.schedule-intervals {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n.schedule-interval {\n  color: #10b981;\n  font-weight: 600;\n  font-size: 0.75rem;\n  padding: 4px 10px;\n  background: rgba(16, 185, 129, 0.1);\n  border-radius: 8px;\n  white-space: nowrap;\n}\n\n/* Orders Container */\n.orders-container {\n  background: var(--bg-primary);\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);\n  border: 1px solid var(--border-color);\n}\n\n.orders-header-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.orders-header-section h2 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.orders-sort-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.sort-label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.sort-select {\n  padding: 6px 12px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  font-size: 0.875rem;\n  background: white;\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.sort-select:hover {\n  border-color: #3b82f6;\n}\n\n.sort-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.btn-sort-direction {\n  padding: 6px 10px;\n  min-width: 36px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  color: var(--text-secondary);\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.btn-sort-direction:hover {\n  background: var(--nav-hover-bg);\n  border-color: #cbd5e1;\n}\n\n.orders-table-wrapper {\n  overflow-x: auto;\n  margin-bottom: 16px;\n}\n\n.orders-table-simple {\n  width: 100%;\n  border-collapse: collapse;\n  background: transparent;\n}\n\n.orders-table-simple thead {\n  background: var(--nav-hover-bg);\n  border-bottom: 2px solid var(--border-color);\n}\n\n.orders-table-simple th {\n  padding: 14px 16px;\n  text-align: left;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--text-secondary);\n  white-space: nowrap;\n}\n\n.orders-table-simple td {\n  padding: 16px;\n  border-bottom: 1px solid var(--border-color);\n  font-size: 0.875rem;\n  color: var(--text-primary);\n  vertical-align: middle;\n}\n\n.orders-table-simple tbody tr:hover {\n  background: var(--nav-hover-bg);\n}\n\n.order-id-cell {\n  font-family: 'Courier New', monospace;\n}\n\n.order-id-text {\n  color: var(--text-secondary);\n  font-size: 0.8rem;\n}\n\n.order-title-cell {\n  max-width: 300px;\n}\n\n.order-title-cell span {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.order-status-cell {\n  white-space: nowrap;\n}\n\n.order-accepted-cell {\n  text-align: center;\n}\n\n.accepted-yes {\n  color: #16a34a;\n  font-size: 1.2rem;\n  font-weight: 600;\n}\n\n.accepted-no {\n  color: #dc2626;\n  font-size: 1.2rem;\n  font-weight: 600;\n}\n\n.order-date-cell {\n  white-space: nowrap;\n  color: var(--text-secondary);\n  font-size: 0.8rem;\n}\n\n.order-actions-cell {\n  white-space: nowrap;\n}\n\n.btn-link-sm {\n  padding: 4px 10px;\n  font-size: 0.8rem;\n  background: #3b82f6;\n  color: white;\n  text-decoration: none;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.btn-link-sm:hover {\n  background: #2563eb;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);\n}\n\n.orders-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 16px;\n  border-top: 1px solid var(--border-color);\n  flex-wrap: wrap;\n}\n\n.pagination-info {\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n.page-size-select {\n  padding: 6px 10px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  font-size: 0.875rem;\n  background: white;\n  color: var(--text-primary);\n  cursor: pointer;\n  margin-left: auto;\n}\n\n.page-size-select:hover {\n  border-color: #3b82f6;\n}\n\n.page-size-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n/* ==========================================================\n   RADICAL DASHBOARD LAYOUT & BENTO GRID \n   ========================================================== */\n\n.user-profile-dashboard {\n  display: grid;\n  grid-template-columns: 280px 1fr;\n  gap: 24px;\n  align-items: start;\n  width: 100%;\n  max-width: 1600px;\n  margin: 0 auto;\n}\n\n@media (max-width: 1200px) {\n  .user-profile-dashboard {\n    grid-template-columns: 280px 1fr;\n  }\n}\n\n/* LEFT SIDEBAR (Minimalist) */\n.profile-sidebar {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 100px;\n  padding: 20px;\n  background: var(--bg-primary);\n  z-index: 10;\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n  border: 1px solid var(--border-color);\n  border-radius: 20px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.profile-stats-sidebar {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 100px;\n  z-index: 10;\n}\n\n[data-theme='dark'] .profile-sidebar {\n  background: var(--bg-secondary);\n  border-color: var(--border-color);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n.sidebar-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 8px;\n  padding-bottom: 8px;\n  border-bottom: none;\n}\n\n[data-theme='dark'] .sidebar-header {\n  border-bottom-color: rgba(255, 255, 255, 0.06);\n}\n\n.sidebar-avatar,\n.sidebar-avatar-placeholder {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: none;\n  box-shadow: none;\n  flex-shrink: 0;\n}\n\n.sidebar-avatar-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 2rem;\n  font-weight: 700;\n  color: white;\n  background: linear-gradient(135deg, #3b82f6, #60a5fa);\n}\n\n.sidebar-avatar-wrap {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n}\n\n/* Аватар кликабелен — открывает просмотрщик */\n.sidebar-avatar-button {\n  position: relative;\n  display: block;\n  padding: 0;\n  border: none;\n  background: transparent;\n  border-radius: 50%;\n  cursor: zoom-in;\n  line-height: 0;\n  overflow: hidden;\n}\n\n.sidebar-avatar-zoom {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: rgba(15, 23, 42, 0.55);\n  color: #fff;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.sidebar-avatar-button:hover .sidebar-avatar-zoom,\n.sidebar-avatar-button:focus-visible .sidebar-avatar-zoom {\n  opacity: 1;\n}\n\n.sidebar-avatar-wrap.status-active {\n  box-shadow:\n    0 0 0 1px rgba(148, 163, 184, 0.35),\n    0 0 0 4px rgba(16, 185, 129, 0.18),\n    0 4px 14px rgba(15, 23, 42, 0.14);\n}\n\n.sidebar-avatar-wrap.status-inactive {\n  box-shadow:\n    0 0 0 1px rgba(148, 163, 184, 0.35),\n    0 0 0 4px rgba(245, 158, 11, 0.17),\n    0 4px 14px rgba(15, 23, 42, 0.14);\n}\n\n.sidebar-avatar-wrap.status-blocked {\n  box-shadow:\n    0 0 0 1px rgba(148, 163, 184, 0.35),\n    0 0 0 4px rgba(239, 68, 68, 0.17),\n    0 4px 14px rgba(15, 23, 42, 0.14);\n}\n\n.sidebar-name {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n  padding: 0;\n  word-break: break-word;\n  max-width: 100%;\n}\n\n.sidebar-name-row {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  max-width: 100%;\n}\n\n.sidebar-verified-image {\n  width: 24px;\n  height: 24px;\n  display: inline-block;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n.sidebar-quick-stats {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding-bottom: 8px;\n  border-bottom: none;\n}\n\n[data-theme='dark'] .sidebar-quick-stats {\n  border-bottom-color: rgba(255, 255, 255, 0.06);\n}\n\n.stat-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.85rem;\n  gap: 8px;\n  padding: 12px 16px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  background: var(--bg-primary);\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.stat-item:hover {\n  border-color: var(--accent-primary);\n  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.08);\n}\n\n.stat-label {\n  color: var(--text-secondary);\n  font-weight: 500;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.stat-value {\n  color: var(--text-primary);\n  font-weight: 600;\n  text-align: right;\n  white-space: nowrap;\n}\n\n.stat-value.mono {\n  font-family: 'Fira Code', 'Fira Sans', monospace;\n  color: #10b981;\n  font-variant-numeric: tabular-nums;\n  font-size: 0.85rem;\n}\n\n.balance-item {\n  background: rgba(16, 185, 129, 0.04);\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1px dashed rgba(16, 185, 129, 0.15);\n  align-items: flex-start;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.balance-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.stat-value.mono.balance-amount-negative {\n  color: #ef4444;\n}\n\n.balance-item:has(.balance-amount-negative) {\n  background: rgba(239, 68, 68, 0.06);\n  border-color: rgba(239, 68, 68, 0.22);\n}\n\n/* Баланс маркетплейса (только для CUSTOMER).\n   Селекторы с .stat-item — чтобы правило .stat-item из order-details.css\n   (flex-direction: row) не ломало колоночную раскладку, если этот файл\n   подключился позже. */\n.stat-item.marketplace-balance-item {\n  cursor: default;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 6px;\n  min-width: 0;\n  background: rgba(99, 102, 241, 0.05);\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1px dashed rgba(99, 102, 241, 0.22);\n}\n\n.stat-item.marketplace-balance-item:hover {\n  border-color: rgba(99, 102, 241, 0.4);\n  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.1);\n  transform: none;\n}\n\n.stat-item.marketplace-balance-item .balance-row {\n  min-width: 0;\n  justify-content: flex-start;\n}\n\n.marketplace-balance-item .marketplace-balance-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  max-width: 100%;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  line-height: 1.3;\n  color: #6366f1;\n}\n\n.marketplace-balance-item .marketplace-balance-label svg {\n  flex-shrink: 0;\n}\n\n.marketplace-balance-item .stat-value.mono.marketplace-balance-value {\n  color: #6366f1;\n  min-width: 0;\n  max-width: 100%;\n  text-align: left;\n  overflow-wrap: anywhere;\n  white-space: normal;\n}\n\n[data-theme='dark'] .marketplace-balance-item {\n  background: rgba(129, 140, 248, 0.08);\n  border-color: rgba(129, 140, 248, 0.28);\n}\n\n[data-theme='dark'] .marketplace-balance-label,\n[data-theme='dark'] .stat-value.mono.marketplace-balance-value {\n  color: #a5b4fc;\n}\n\n.debt-status-item {\n  cursor: default;\n  background: rgba(245, 158, 11, 0.07);\n  border-color: rgba(245, 158, 11, 0.28);\n  align-items: flex-start;\n}\n\n.debt-status-item:hover {\n  border-color: rgba(245, 158, 11, 0.4);\n  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.12);\n}\n\n.provider-verified-stat {\n  cursor: default;\n}\n\n.provider-verified-value.is-verified {\n  color: #16a34a;\n}\n\n.provider-verified-value.is-unverified {\n  color: #b45309;\n}\n\n.stat-value.debt-status-value {\n  color: #b45309;\n  font-weight: 600;\n  font-size: 0.8rem;\n  line-height: 1.3;\n  text-align: right;\n  white-space: normal;\n  max-width: 58%;\n  word-break: break-word;\n}\n\n[data-theme='dark'] .stat-value.debt-status-value {\n  color: #fbbf24;\n}\n\n[data-theme='dark'] .debt-status-item {\n  background: rgba(245, 158, 11, 0.1);\n  border-color: rgba(245, 158, 11, 0.3);\n}\n\n[data-theme='dark'] .stat-value.mono.balance-amount-negative {\n  color: #f87171;\n}\n\n/* SIDEBAR NAVIGATION (Vertical) */\n.sidebar-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.nav-tab-side {\n  display: flex;\n  align-items: center;\n  padding: 10px 16px;\n  border: 1px solid var(--border-color);\n  background: var(--bg-primary);\n  color: var(--text-secondary);\n  border-radius: 12px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  text-align: left;\n}\n\n.nav-tab-side:hover:not(.active) {\n  background: var(--nav-hover-bg);\n  border-color: #cbd5e1;\n  color: var(--text-primary);\n}\n\n[data-theme='dark'] .nav-tab-side:hover:not(.active) {\n  background: rgba(59, 130, 246, 0.1);\n}\n\n.nav-tab-side.active {\n  color: var(--accent-primary);\n  background: rgba(59, 130, 246, 0.08);\n  border-color: rgba(59, 130, 246, 0.3);\n  font-weight: 600;\n}\n\n.nav-side-active-bg {\n  display: none;\n}\n\n.nav-tab-side-content {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  white-space: nowrap;\n}\n\n/* MAIN CONTENT AREA */\n.profile-dashboard-main {\n  min-width: 0;\n  /* Prevents overflow in grid */\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* BENTO GRID LAYOUT */\n.bento-grid-layout {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  align-items: stretch;\n}\n\n.bento-card {\n  position: relative;\n  background: rgba(255, 255, 255, 0.7);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.03);\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.3s ease, opacity 0.3s ease, border-color 0.3s ease;\n  cursor: grab;\n}\n\n[data-theme='dark'] .bento-card {\n  background: rgba(30, 41, 59, 0.4);\n  border-color: rgba(255, 255, 255, 0.05);\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);\n}\n\n.bento-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.06);\n}\n\n.bento-small {\n  grid-column: span 1;\n  min-height: 200px;\n}\n\n.bento-medium {\n  grid-column: span 2;\n}\n\n.bento-large {\n  grid-column: span 2;\n  min-height: 200px;\n}\n\n/* RESPONSIVE DASHBOARD */\n@media (max-width: 1024px) {\n  .user-profile-dashboard {\n    grid-template-columns: 1fr;\n  }\n\n  .profile-sidebar {\n    position: relative;\n    top: 0;\n    max-width: 100%;\n  }\n\n  .bento-grid-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .bento-small,\n  .bento-medium,\n  .bento-large {\n    grid-column: span 1;\n  }\n}\n\n/* BENTO CARD UPGRADES */\n.bento-card .card-header {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  padding-bottom: 0 !important;\n  margin-bottom: 12px !important;\n  border-bottom: none !important;\n}\n\n.id-value-fixed {\n  flex: 1 !important;\n  min-width: 0 !important;\n  word-break: break-all !important;\n  overflow-wrap: break-word !important;\n  padding-right: 28px !important;\n}\n\n.bento-card .card-icon-circle {\n  background: rgba(59, 130, 246, 0.08);\n  color: #3b82f6;\n  border: none;\n  box-shadow: inset 0 0 0 1px rgba(59, 130, 246, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n}\n\n.bento-card .card-title {\n  font-size: 0.95rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 0;\n  color: var(--text-primary);\n  letter-spacing: -0.01em;\n}\n\n/* Drag & Drop States */\n/* Полностью прячем оригинал, чтобы клон летел на пустое место */\n/* 1. Превращаем оригинальную карточку в \"пустой слот\" при взятии */\n.bento-card.dragging {\n  opacity: 0 !important;\n  transition: none !important;\n  /* Убираем любые плавные появления для оригинала */\n  pointer-events: none;\n}\n\n.bento-card.dragging>* {\n  opacity: 0 !important;\n  /* Прячем контент внутри слота */\n}\n\n.bento-card.drag-over {\n  border-color: rgba(59, 130, 246, 0.6);\n  /* Ячейка-цель слегка уменьшается \"вдавливается\" */\n  transform: scale(0.85);\n  box-shadow: inset 0 0 0 2px rgba(59, 130, 246, 0.15), 0 4px 12px rgba(0, 0, 0, 0.05);\n  background: rgba(59, 130, 246, 0.04);\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.bento-card.drag-over::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  border-radius: 16px;\n  background: rgba(59, 130, 246, 0.04);\n  pointer-events: none;\n  z-index: 10;\n}\n\n.bento-card.pinned {\n  border-color: rgba(16, 185, 129, 0.15);\n  cursor: default;\n}\n\n.bento-card:active:not(.pinned) {\n  cursor: grabbing;\n}\n\n/* Pin Button */\n.btn-pin-card {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: var(--text-secondary);\n  opacity: 0;\n  transition: all 0.2s ease;\n  padding: 6px;\n  border-radius: 8px;\n  flex-shrink: 0;\n  z-index: 10;\n  margin-right: -6px;\n}\n\n.bento-card:hover .btn-pin-card {\n  opacity: 0.4;\n}\n\n.bento-card:hover .btn-pin-card:hover {\n  opacity: 1;\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.btn-pin-card.pinned {\n  opacity: 1;\n  color: #ef4444;\n}\n\n.btn-pin-card.pinned:hover {\n  color: #dc2626;\n  background: rgba(239, 68, 68, 0.08);\n}\n\n.info-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0;\n  border-bottom: 1px dashed rgba(0, 0, 0, 0.06);\n}\n\n.info-row:last-child {\n  border-bottom: none;\n}\n\n.info-label {\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  font-weight: 500;\n  flex: 1;\n}\n\n.info-value {\n  color: var(--text-primary);\n  font-size: 0.9rem;\n  font-weight: 500;\n  flex: 1.5;\n  text-align: right;\n  word-break: break-all;\n}\n\n.info-value.highlight {\n  color: #3b82f6;\n  font-weight: 600;\n}\n\n.info-value.mono-token {\n  font-family: 'Fira Code', 'Fira Sans', monospace;\n  background: rgba(255, 255, 255, 0.4);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  padding: 6px 12px;\n  border-radius: 8px;\n  font-size: 0.85rem;\n  display: inline-flex;\n  align-items: center;\n  border: 1px dashed rgba(59, 130, 246, 0.3);\n  color: var(--text-primary);\n}\n\n[data-theme='dark'] .info-value.mono-token {\n  background: rgba(30, 41, 59, 0.5);\n  border-color: rgba(96, 165, 250, 0.2);\n}\n\n/* ==========================================================\n   ACTION TABS UPGRADES (Reviews, Interaction, Orders)\n   ========================================================== */\n\n.reviews-container,\n.interaction-container,\n.orders-container {\n  background: rgba(255, 255, 255, 0.7);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border-radius: 20px;\n  padding: 32px;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.03);\n}\n\n[data-theme='dark'] .reviews-container,\n[data-theme='dark'] .interaction-container,\n[data-theme='dark'] .orders-container {\n  background: rgba(30, 41, 59, 0.4);\n  border-color: rgba(255, 255, 255, 0.05);\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);\n}\n\n/* Refresh Button in Reviews */\n.btn-refresh-reviews {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: transparent;\n  color: #3b82f6;\n  border: 1px solid rgba(59, 130, 246, 0.3);\n  padding: 8px 16px;\n  border-radius: 99px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-refresh-reviews:hover {\n  background: rgba(59, 130, 246, 0.1);\n  border-color: rgba(59, 130, 246, 0.5);\n}\n\n.btn-refresh-reviews .spinning {\n  animation: spin 1s linear infinite;\n}\n\n/* Empty States */\n.reviews-empty-state {\n  opacity: 0.8;\n  transform: scale(0.95);\n}\n\n/* Interaction Status Segmented Control */\n.interaction-section h2 {\n  font-size: 1.15rem;\n  font-weight: 700;\n  margin-bottom: 16px;\n  color: var(--text-primary);\n}\n\n.status-inline {\n  display: inline-flex;\n  background: rgba(0, 0, 0, 0.04);\n  padding: 6px;\n  border-radius: 12px;\n  gap: 4px;\n  border: 1px solid rgba(0, 0, 0, 0.02);\n}\n\n[data-theme='dark'] .status-inline {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.status-inline .btn-status {\n  background: transparent;\n  color: var(--text-secondary);\n  border: none;\n  font-weight: 500;\n  padding: 8px 16px;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n}\n\n.status-inline .btn-status:hover {\n  background: rgba(0, 0, 0, 0.03);\n  color: var(--text-primary);\n}\n\n[data-theme='dark'] .status-inline .btn-status:hover {\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.status-inline .btn-status .dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  background: currentColor;\n  opacity: 0.55;\n  transition: all 0.3s ease;\n}\n\n.status-inline .btn-status .dot-green { color: #10b981; }\n.status-inline .btn-status .dot-yellow { color: #f59e0b; }\n.status-inline .btn-status .dot-red { color: #ef4444; }\n\n.status-inline .btn-status.active {\n  background: white;\n  color: var(--text-primary);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  font-weight: 600;\n}\n\n.status-inline .btn-status.active .dot {\n  opacity: 1;\n  box-shadow: 0 0 0 3px color-mix(in srgb, currentColor 22%, transparent);\n}\n\n[data-theme='dark'] .status-inline .btn-status.active {\n  background: var(--accent-primary);\n  color: #fff;\n  box-shadow: 0 4px 14px rgba(59, 130, 246, 0.45);\n}\n\n[data-theme='dark'] .status-inline .btn-status.active .dot {\n  color: #fff;\n  opacity: 1;\n  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.3);\n}\n\n/* ── Verification Banner ── */\n.verification-banner {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 18px 20px;\n  border-radius: 16px;\n  border: 1px solid transparent;\n  position: relative;\n  overflow: hidden;\n  transition: box-shadow 0.2s ease;\n}\n\n.verification-banner::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  opacity: 0.045;\n  pointer-events: none;\n}\n\n.verification-banner.is-verified {\n  background: linear-gradient(135deg, rgba(22,163,74,0.10) 0%, rgba(16,185,129,0.06) 100%);\n  border-color: rgba(22, 163, 74, 0.22);\n}\n\n.verification-banner.is-verified::before {\n  background: radial-gradient(circle at 0% 50%, #22c55e 0%, transparent 70%);\n  opacity: 0.12;\n}\n\n.verification-banner.is-unverified {\n  background: linear-gradient(135deg, rgba(245,158,11,0.10) 0%, rgba(251,191,36,0.06) 100%);\n  border-color: rgba(245, 158, 11, 0.22);\n}\n\n.verification-banner.is-unverified::before {\n  background: radial-gradient(circle at 0% 50%, #f59e0b 0%, transparent 70%);\n  opacity: 0.10;\n}\n\n[data-theme='dark'] .verification-banner.is-verified {\n  background: linear-gradient(135deg, rgba(34,197,94,0.12) 0%, rgba(16,185,129,0.07) 100%);\n  border-color: rgba(34, 197, 94, 0.2);\n}\n\n[data-theme='dark'] .verification-banner.is-unverified {\n  background: linear-gradient(135deg, rgba(251,191,36,0.12) 0%, rgba(245,158,11,0.07) 100%);\n  border-color: rgba(251, 191, 36, 0.2);\n}\n\n.verification-banner-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  flex-shrink: 0;\n}\n\n.verification-banner.is-verified .verification-banner-icon {\n  background: rgba(22, 163, 74, 0.14);\n  color: #16a34a;\n}\n\n.verification-banner.is-unverified .verification-banner-icon {\n  background: rgba(245, 158, 11, 0.14);\n  color: #d97706;\n}\n\n[data-theme='dark'] .verification-banner.is-verified .verification-banner-icon {\n  background: rgba(34, 197, 94, 0.18);\n  color: #4ade80;\n}\n\n[data-theme='dark'] .verification-banner.is-unverified .verification-banner-icon {\n  background: rgba(251, 191, 36, 0.18);\n  color: #fbbf24;\n}\n\n.verification-banner-body {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n  min-width: 0;\n}\n\n.verification-banner-title {\n  font-size: 0.78rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--text-secondary);\n}\n\n.verification-banner-status {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.verification-banner.is-verified .verification-banner-status {\n  color: #15803d;\n}\n\n.verification-banner.is-unverified .verification-banner-status {\n  color: #b45309;\n}\n\n[data-theme='dark'] .verification-banner.is-verified .verification-banner-status {\n  color: #4ade80;\n}\n\n[data-theme='dark'] .verification-banner.is-unverified .verification-banner-status {\n  color: #fbbf24;\n}\n\n.verification-banner-btn {\n  flex-shrink: 0;\n  border-radius: 10px;\n  font-size: 0.84rem;\n  font-weight: 600;\n  padding: 9px 18px;\n  transition: all 0.2s ease;\n}\n\n.btn-verify {\n  background: #16a34a;\n  color: #fff;\n  border: none;\n  box-shadow: 0 2px 8px rgba(22,163,74,0.28);\n}\n\n.btn-verify:hover:not(:disabled) {\n  background: #15803d;\n  box-shadow: 0 4px 14px rgba(22,163,74,0.36);\n  transform: translateY(-1px);\n}\n\n.btn-unverify {\n  background: transparent;\n  color: #b91c1c;\n  border: 1px solid rgba(239,68,68,0.32);\n}\n\n.btn-unverify:hover:not(:disabled) {\n  background: rgba(239,68,68,0.08);\n  border-color: rgba(239,68,68,0.5);\n}\n\n[data-theme='dark'] .btn-unverify {\n  color: #fca5a5;\n  border-color: rgba(248,113,113,0.3);\n}\n\n[data-theme='dark'] .btn-unverify:hover:not(:disabled) {\n  background: rgba(248,113,113,0.1);\n}\n\n/* ── Verification Confirm Modal ── */\n.verification-confirm-modal {\n  max-width: min(560px, calc(100vw - 32px));\n}\n\n.verification-confirm-text {\n  margin: 0;\n  font-size: 0.95rem;\n  line-height: 1.6;\n}\n\n/* Interaction Textarea */\n.note-textarea {\n  width: 100%;\n  padding: 16px;\n  background: rgba(255, 255, 255, 0.5);\n  border: 1px dashed rgba(0, 0, 0, 0.1);\n  border-radius: 16px;\n  color: var(--text-primary);\n  font-family: inherit;\n  font-size: 0.95rem;\n  resize: vertical;\n  transition: all 0.3s ease;\n  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.01);\n}\n\n.note-textarea:focus {\n  outline: none;\n  background: white;\n  border: 1px solid #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\n}\n\n[data-theme='dark'] .note-textarea {\n  background: rgba(0, 0, 0, 0.1);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme='dark'] .note-textarea:focus {\n  background: rgba(30, 41, 59, 0.5);\n}\n\n/* Save / Clear Buttons */\n.note-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.note-actions .btn-secondary {\n  background: transparent;\n  border: none;\n  color: var(--text-secondary);\n}\n\n.note-actions .btn-secondary:hover:not(:disabled) {\n  background: rgba(0, 0, 0, 0.05);\n  color: var(--text-primary);\n}\n\n.note-actions .btn-primary {\n  background: #3b82f6;\n  color: white;\n  padding: 10px 24px;\n  border-radius: 12px;\n  font-weight: 600;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n.note-actions .btn-primary:hover:not(:disabled) {\n  background: #2563eb;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.4);\n}\n\n.card-content {\n  padding-top: 4px;\n}\n\n/* ===== Interaction tab: section heads + review form ===== */\n.interaction-section-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  margin-bottom: 18px;\n}\n\n/* Collapsible section toggle (admin review) */\n.interaction-section-toggle {\n  width: 100%;\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n  align-items: center;\n}\n\n.interaction-section-chevron {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: auto;\n  color: var(--text-secondary);\n  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.review-section.is-open .interaction-section-chevron {\n  transform: rotate(180deg);\n}\n\n.review-section.is-collapsed .interaction-section-toggle {\n  margin-bottom: 0;\n}\n\n.interaction-section-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 12px;\n  background: rgba(59, 130, 246, 0.12);\n  color: #3b82f6;\n}\n\n.interaction-section-icon.accent-amber {\n  background: rgba(245, 158, 11, 0.14);\n  color: #f59e0b;\n}\n\n.interaction-section-titles {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.interaction-section-head h2 {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n  line-height: 1.3;\n}\n\n.interaction-section-sub {\n  font-size: 0.82rem;\n  color: var(--text-secondary);\n  margin: 0;\n  line-height: 1.4;\n}\n\n/* Review form (masters / providers) */\n.review-section {\n  padding: 20px;\n  border-radius: 16px;\n  border: 1px solid rgba(245, 158, 11, 0.22);\n  background: linear-gradient(135deg, rgba(245, 158, 11, 0.06) 0%, rgba(251, 191, 36, 0.03) 100%);\n}\n\n[data-theme='dark'] .review-section {\n  border-color: rgba(245, 158, 11, 0.2);\n  background: linear-gradient(135deg, rgba(245, 158, 11, 0.08) 0%, rgba(251, 191, 36, 0.04) 100%);\n}\n\n.review-form {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.review-field-label {\n  display: block;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  margin-bottom: 8px;\n}\n\n.review-input-field,\n.review-rating-field {\n  display: flex;\n  flex-direction: column;\n}\n\n.review-stars-input {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.review-star-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px;\n  border: none;\n  background: transparent;\n  color: rgba(148, 163, 184, 0.55);\n  cursor: pointer;\n  border-radius: 8px;\n  transition: transform 0.15s ease, color 0.15s ease;\n}\n\n.review-star-btn:hover {\n  transform: scale(1.15);\n}\n\n.review-star-btn.active {\n  color: #f59e0b;\n}\n\n.review-rating-value {\n  margin-left: 10px;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.review-text-input {\n  width: 100%;\n  padding: 12px 14px;\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  font-size: 0.875rem;\n  font-family: inherit;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.review-text-input::placeholder {\n  color: var(--text-secondary);\n  opacity: 0.6;\n  font-family: monospace;\n}\n\n.review-text-input:focus {\n  outline: none;\n  border-color: #f59e0b;\n  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.12);\n}\n/* Тёмная тема (DEV): оставшиеся белые поверхности (тост и селекты) */\n:root[data-theme='dark'] .message-toast {\n  background: var(--bg-card);\n  color: var(--text-primary);\n}\n\n:root[data-theme='dark'] .sort-select,\n:root[data-theme='dark'] .page-size-select {\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n\n/* Marketing consent pill (System info card) */\n.marketing-consent-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 2px 10px 2px 8px;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  line-height: 1.6;\n  border: 1px solid transparent;\n}\n\n.marketing-consent-pill.is-agreed {\n  color: #059669;\n  background: rgba(16, 185, 129, 0.1);\n  border-color: rgba(16, 185, 129, 0.25);\n}\n\n.marketing-consent-pill.is-declined {\n  color: #dc2626;\n  background: rgba(239, 68, 68, 0.08);\n  border-color: rgba(239, 68, 68, 0.22);\n}\n\n.marketing-consent-pill.is-no-answer {\n  color: var(--text-secondary);\n  background: var(--bg-tertiary);\n  border-color: var(--border-color);\n}\n\n:root[data-theme='dark'] .marketing-consent-pill.is-agreed {\n  color: #34d399;\n}\n\n:root[data-theme='dark'] .marketing-consent-pill.is-declined {\n  color: #f87171;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
